import React, {useEffect, useState, useRef, useContext } from "react"

import {Navigate, useNavigate, useLocation} from 'react-router-dom'

import { Grid, FormControlLabel, Chip, Menu, InputAdornment, ListItemIcon, ListItemSecondaryAction, Container, Table, MenuItem, TableBody, TableCell, TableContainer, TableHead, TableRow, LinearProgress, DialogContent, makeStyles, Checkbox, CardActionArea, AccordionActions, Button, TextField, Badge, CardActions, DialogActions, DialogContentText, Grow, Tooltip, Card, Dialog, ListItemText, IconButton, ListItemAvatar, Typography, CardContent, Avatar, Snackbar, List, DialogTitle, ListItem, CircularProgress, Divider, Paper, Accordion, AccordionSummary, AccordionDetails  } from '@material-ui/core';

import {HelperStepsContext, ProactiveContext, HelpActivatedContext, ExamZeroCaseContext, medicinesSuggestedContext, DhcpContext, uninsuredExeptionChosenContext, MedicinesAutocompleteContext, DiagnosisAutocompleteContext, ExamsAutocompleteContext, ExamsRegisteredContext, ReferralCommentFinalContext, ZeroCaseNumberContext, ZeroCaseDateContext, PatientProtocolHistoryContext, RegisteredRefferalsContext, recomendationInfoContext, VisitIdContext, PrescriptionRegisteredContext, MedicationRegisteredContext, LoggedContext, DataContext, UnitContext, LimitContext, QuotaContext, InsuranceContext, PatientInfoContext} from '../../Context'

import { ExpandMore, EmojiObjects, HelpOutline, Storage, Person, Message, Send, Print, Close, Search, Today, DateRange, Euro, Delete, AccountBox, Info, Done, NotInterested, CheckCircle, VerticalAlignTop, VerticalAlignCenter, Sms, PeopleAlt, LocalHospital, Refresh, RadioButtonUnchecked  } from '@material-ui/icons';

import {FaHospital, FaFilePrescription, FaNotesMedical, FaCommentMedical, FaUserMd, FaSyringe, FaStethoscope, FaPercent, FaUserInjured, FaIdBadge, FaUser, } from "react-icons/fa";

import MedicinesAndPills from '../visits.svg'

import { Alert } from '@material-ui/lab';

import {HelperPoper} from '../Prescriptions/Prescriptions'

import { useDemoStore } from '../../Stores/demoStore'

import useStore from '../../Stores/prescriptionStore';


import {PrescriptionDashboard} from'../MainPage/Fab'

const mockVisits = [
  
  {
    id: "V1001",
    patientInfo: {
      lastName: "Παπαδόπουλος",
      firstName: "Γιώργος",
      amka: "12345678901",
      socialInsuranceShortName: "ΕΟΠΥΥ"
    },
    startDate: "2025-02-18 09:00",
    status: { id: 2, status: "ΟΛΟΚΛΗΡΩΜΕΝΗ" },
    inQuota: true,
    Prescriptions: [
      {
        Prescription_Barcode: "RX100001",
        Prescription_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΗ",
        Treatment: [
          {
            Medication: "Παρακεταμόλη 500mg",
            Quantity_Value: 2,
            Dose_Value: 1,
            Dose_Unit: "Δισκίο",
            Frequency: "Κάθε 8 ώρες",
            Duration_Value: 7,
            Diagnosis: ["Πυρετός"]
          }
        ]
      }
    ],
    Referrals: [],
    timestamp: Date.now(),
    ConsentPrescription: true,
    ConsentRefferal: true
  },
  {
    id: "V1002",
    patientInfo: {
      lastName: "Αντωνίου",
      firstName: "Μαρία",
      amka: "23456789012",
      socialInsuranceShortName: "ΕΟΠΥΥ"
    },
    startDate: "2025-02-18 10:30",
    status: { id: 2, status: "ΟΛΟΚΛΗΡΩΜΕΝΗ" },
    inQuota: true,
    Prescriptions: [
      {
        Prescription_Barcode: "RX100002",
        Prescription_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΗ",
        Treatment: [
          {
            Medication: "Ομεπραζόλη 20mg",
            Quantity_Value: 1,
            Dose_Value: 1,
            Dose_Unit: "Κάψουλα",
            Frequency: "Μία φορά την ημέρα",
            Duration_Value: 30,
            Diagnosis: ["Γαστροοισοφαγική παλινδρόμηση"]
          }
        ]
      }
    ],
    Referrals: [
      {
        Referral_Barcode: "RF100002",
        Referral_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΟ",
        Test: [
          {
            Procedure: "Γαστροσκόπηση",
            Status: "Σε αναμονή",
            Diagnosis: "Χρόνια γαστρίτιδα"
          }
        ]
      }
    ],
    timestamp: Date.now(),
    ConsentPrescription: true,
    ConsentRefferal: true
  },
  {
    id: "V1003",
    patientInfo: {
      lastName: "Δημητρίου",
      firstName: "Νίκος",
      amka: "34567890123",
      socialInsuranceShortName: "ΕΟΠΥΥ"
    },
    startDate: "2025-02-18 11:45",
    status: { id: 2, status: "ΟΛΟΚΛΗΡΩΜΕΝΗ" },
    inQuota: true,
    Prescriptions: [
      {
        Prescription_Barcode: "RX100003",
        Prescription_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΗ",
        Treatment: [
          {
            Medication: "Ατορβαστατίνη 20mg",
            Quantity_Value: 1,
            Dose_Value: 1,
            Dose_Unit: "Δισκίο",
            Frequency: "Μία φορά την ημέρα",
            Duration_Value: 30,
            Diagnosis: ["Υπερλιπιδαιμία"]
          }
        ]
      }
    ],
    Referrals: [
      {
        Referral_Barcode: "RF100003",
        Referral_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΟ",
        Test: [
          {
            Procedure: "Λιπιδαιμικό προφίλ",
            Status: "Σε αναμονή",
            Diagnosis: "Τακτικός έλεγχος"
          }
        ]
      }
    ],
    timestamp: Date.now(),
    ConsentPrescription: true,
    ConsentRefferal: true
  },
  {
    id: "V1004",
    patientInfo: {
      lastName: "Κωνσταντίνου",
      firstName: "Ελένη",
      amka: "45678901234",
      socialInsuranceShortName: "ΕΟΠΥΥ"
    },
    startDate: "2025-02-18 13:00",
    status: { id: 2, status: "ΟΛΟΚΛΗΡΩΜΕΝΗ" },
    inQuota: true,
    Prescriptions: [
      {
        Prescription_Barcode: "RX100004",
        Prescription_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΗ",
        Treatment: [
          {
            Medication: "Βρωμαζεπάμη 3mg",
            Quantity_Value: 1,
            Dose_Value: 1,
            Dose_Unit: "Δισκίο",
            Frequency: "Πριν τον ύπνο",
            Duration_Value: 30,
            Diagnosis: ["Αγχώδης διαταραχή"]
          }
        ]
      }
    ],
    Referrals: [
      {
        Referral_Barcode: "RF100004",
        Referral_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΟ",
        Test: [
          {
            Procedure: "Ψυχιατρική εκτίμηση",
            Status: "Σε αναμονή",
            Diagnosis: "Άγχος και αϋπνία"
          }
        ]
      }
    ],
    timestamp: Date.now(),
    ConsentPrescription: true,
    ConsentRefferal: true
  },
  {
    id: "V1005",
    patientInfo: {
      lastName: "Βασιλείου",
      firstName: "Αντώνης",
      amka: "56789012345",
      socialInsuranceShortName: "ΕΟΠΥΥ"
    },
    startDate: "2025-02-18 14:15",
    status: { id: 2, status: "ΟΛΟΚΛΗΡΩΜΕΝΗ" },
    inQuota: true,
    Prescriptions: [
      {
        Prescription_Barcode: "RX100005",
        Prescription_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΗ",
        Treatment: [
          {
            Medication: "Μετφορμίνη 1000mg",
            Quantity_Value: 2,
            Dose_Value: 1,
            Dose_Unit: "Δισκίο",
            Frequency: "Δύο φορές την ημέρα",
            Duration_Value: 30,
            Diagnosis: ["Σακχαρώδης διαβήτης τύπου 2"]
          }
        ]
      }
    ],
    Referrals: [
      {
        Referral_Barcode: "RF100005",
        Referral_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΟ",
        Test: [
          {
            Procedure: "HbA1c",
            Status: "Σε αναμονή",
            Diagnosis: "Παρακολούθηση διαβήτη"
          }
        ]
      }
    ],
    timestamp: Date.now(),
    ConsentPrescription: true,
    ConsentRefferal: true
  },
  {
    id: "V1006",
    patientInfo: {
      lastName: "Γεωργίου",
      firstName: "Σοφία",
      amka: "67890123456",
      socialInsuranceShortName: "ΕΟΠΥΥ"
    },
    startDate: "2025-02-18 15:30",
    status: { id: 2, status: "ΟΛΟΚΛΗΡΩΜΕΝΗ" },
    inQuota: true,
    Prescriptions: [
      {
        Prescription_Barcode: "RX100006",
        Prescription_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΗ",
        Treatment: [
          {
            Medication: "Αμοξικιλλίνη/Κλαβουλανικό οξύ 875/125mg",
            Quantity_Value: 2,
            Dose_Value: 1,
            Dose_Unit: "Δισκίο",
            Frequency: "Κάθε 12 ώρες",
            Duration_Value: 10,
            Diagnosis: ["Αμυγδαλίτιδα"]
          }
        ]
      }
    ],
    Referrals: [],
    timestamp: Date.now(),
    ConsentPrescription: true,
    ConsentRefferal: true
  },
  {
    id: "V1007",
    patientInfo: {
      lastName: "Μακρής",
      firstName: "Δημήτρης",
      amka: "78901234567",
      socialInsuranceShortName: "ΕΟΠΥΥ"
    },
    startDate: "2025-02-18 16:45",
    status: { id: 2, status: "ΟΛΟΚΛΗΡΩΜΕΝΗ" },
    inQuota: true,
    Prescriptions: [
      {
        Prescription_Barcode: "RX100007",
        Prescription_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΗ",
        Treatment: [
          {
            Medication: "Ακετυλοσαλικυλικό οξύ 100mg",
            Quantity_Value: 1,
            Dose_Value: 1,
            Dose_Unit: "Δισκίο",
            Frequency: "Μία φορά την ημέρα",
            Duration_Value: 30,
            Diagnosis: ["Πρόληψη καρδιαγγειακών επεισοδίων"]
          }
        ]
      }
    ],
    Referrals: [
      {
        Referral_Barcode: "RF100007",
        Referral_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΟ",
        Test: [
          {
            Procedure: "Καρδιολογική εξέταση",
            Status: "Σε αναμονή",
            Diagnosis: "Τακτικός καρδιολογικός έλεγχος"
          }
        ]
      }
    ],
    timestamp: Date.now(),
    ConsentPrescription: true,
    ConsentRefferal: true
  },
  {
    id: "V1008",
    patientInfo: {
      lastName: "Καραγιάννης",
      firstName: "Ανδρέας",
      amka: "89012345678",
      socialInsuranceShortName: "ΕΟΠΥΥ"
    },
    startDate: "2025-02-18 17:30",
    status: { id: 2, status: "ΟΛΟΚΛΗΡΩΜΕΝΗ" },
    inQuota: true,
    Prescriptions: [
      {
        Prescription_Barcode: "RX100008",
        Prescription_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΗ",
        Treatment: [
          {
            Medication: "Βουδεσονίδη/Φορμοτερόλη 160/4.5μg",
            Quantity_Value: 1,
            Dose_Value: 2,
            Dose_Unit: "Εισπνοή",
            Frequency: "Δύο φορές την ημέρα",
            Duration_Value: 30,
            Diagnosis: ["Άσθμα"]
          }
        ]
      }
    ],
    Referrals: [
      {
        Referral_Barcode: "RF100008",
        Referral_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΟ",
        Test: [
          {
            Procedure: "Σπιρομέτρηση",
            Status: "Σε αναμονή",
            Diagnosis: "Παρακολούθηση άσθματος"
          }
        ]
      }
    ],
    timestamp: Date.now(),
    ConsentPrescription: true,
    ConsentRefferal: true
  },
  {
    id: "V1009",
    patientInfo: {
      lastName: "Παππάς",
      firstName: "Κώστας",
      amka: "90123456789",
      socialInsuranceShortName: "ΕΟΠΥΥ"
    },
    startDate: "2025-02-18 18:15",
    status: { id: 2, status: "ΟΛΟΚΛΗΡΩΜΕΝΗ" },
    inQuota: true,
    Prescriptions: [
      {
        Prescription_Barcode: "RX100009",
        Prescription_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΗ",
        Treatment: [
          {
            Medication: "Λεβοθυροξίνη 100μg",
            Quantity_Value: 1,
            Dose_Value: 1,
            Dose_Unit: "Δισκίο",
            Frequency: "Μία φορά την ημέρα",
            Duration_Value: 30,
            Diagnosis: ["Υποθυρεοειδισμός"]
          }
        ]
      }
    ],
    Referrals: [
      {
        Referral_Barcode: "RF100009",
        Referral_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΟ",
        Test: [
          {
            Procedure: "Θυρεοειδικός έλεγχος",
            Status: "Σε αναμονή",
            Diagnosis: "Παρακολούθηση θυρεοειδούς"
          }
        ]
      }
    ],
    timestamp: Date.now(),
    ConsentPrescription: true,
    ConsentRefferal: true
  },
  {
    id: "V1010",
    patientInfo: {
      lastName: "Αλεξίου",
      firstName: "Χριστίνα",
      amka: "01234567890",
      socialInsuranceShortName: "ΕΟΠΥΥ"
    },
    startDate: "2025-02-18 19:00",
    status: { id: 2, status: "ΟΛΟΚΛΗΡΩΜΕΝΗ" },
    inQuota: true,
    Prescriptions: [
      {
        Prescription_Barcode: "RX100010",
        Prescription_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΗ",
        Treatment: [
          {
            Medication: "Λεβοσετιριζίνη 5mg",
            Quantity_Value: 1,
            Dose_Value: 1,
            Dose_Unit: "Δισκίο",
            Frequency: "Μία φορά την ημέρα",
            Duration_Value: 30,
            Diagnosis: ["Αλλεργική ρινίτιδα"]
          }
        ]
      }
    ],
    Referrals: [
      {
        Referral_Barcode: "RF100010",
        Referral_Status: "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΟ",
        Test: [
          {
            Procedure: "Αλλεργικός έλεγχος",
            Status: "Σε αναμονή",
            Diagnosis: "Διερεύνηση αλλεργιών"
          }
        ]
      }
    ],
    timestamp: Date.now(),
    ConsentPrescription: true,
    ConsentRefferal: true
}]



/*
  Component that shows the completed doctor visits.
  The visits are filtered by amka, and time period. 
  Each visit shows the prescriptions and refferals the doctor prectibed and the corresponding medications and tests.
  When the doctor selects a visit, he can print, resend or cancel each prescription and referral.
  Renders a Card and a Dialog (for presenting the visit informatiion)
  Resets the Context that needs to be reseted for the new visit
*/
const Visits = () => {

  const newVisit = useStore(state => state.newVisit);
  //Force update on "Visits" component
  const [visits, setVisits] = useState(newVisit? [newVisit]:[])
  const [amkaDialogOpen, setAmkaDialogOpen] = useState(false)
  const setDemoMessage = useDemoStore(state => state.setDemoMessage)

  /*
    Present all the visits from a single patient
    Renders a Dialog with a search text and a snackbar in case of error
  */
  const AmkaSearch = () =>{

    //Holds the amka
    const [searchAmka, setsearchAmka] = useState("")


  

    //Return all the visits for the selected amka
    async function searchByAmka() {
      setDemoMessage({
        status:true,
        severity:"info",
        description:"το κουμπί αυτό εμφανίσει τις επισκέψεις του ασθενή που αναζητήσατε."
      })
    }

    //Close the amka search Dialog 
    function closeDialog (){
      setAmkaDialogOpen(false)
    }

 

    

    return(
      
      <Dialog maxWidth='md' open={amkaDialogOpen} onClose={closeDialog}>
        <DialogTitle>Αναζήτηση μέσω ΑΜΚΑ</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Παρακαλώ εισάγετε ένα εγκυρο ΑΜΚΑ ασθενούς 11 ψηφίων. Θα γίνει αναζήτηση ΜΟΝΟ των επισκέψεων του ασθενή σε εσάς 
          και όχι ολών των επισκέψεων του ασθενή σε άλλους ιατρούς. 
          </DialogContentText>
         
          <TextField
            autoComplete="off"
            onKeyPress={(event) => {
              if(event.key === 'Enter' ){ searchByAmka()}
            }}
            variant='outlined'
            autoFocus
            id="amka"
            label="AMKA"
            fullWidth
            value={searchAmka}
            onChange={event=>{setsearchAmka(event.target.value)}}
            error={searchAmka.toString().length > 11 || /^(\s*|\d+)$/.test(searchAmka)===false}
            helperText={searchAmka.toString().length > 11 || /^(\s*|\d+)$/.test(searchAmka)===false ? 'Εισάγετε έναν έγκυρο αριθμό ΑΜΚΑ' : null }
          />
          

        </DialogContent>
        <DialogActions>
          <Button onClick={()=>closeDialog()} color="secondary">
            ΕΠΙΣΤΡΟΦΗ
          </Button>
          <Button onClick={()=>{ searchByAmka()}} color="primary">
            ΑΝΑΖΗΤΗΣΗ
          </Button>
        </DialogActions>
      </Dialog>

    )
  }
  /*
  Component that filters the visits. Criteria: AMKA / time (month/day) 
  Renders 3 buttons
  */
  const VisitsFilter = () =>{

    //HelpActivatedContext data the tooltips show condition
    const [helpActivatedTooltips, setHelpActivatedTooltips] = useContext(HelpActivatedContext)

    //Loads the visits of today
    const todayLoad = async ()=>{
      setVisits(mockVisits.slice(0,5))
    }
    //Loads the visits of the current month
    const monthLoad = async ()=>{
      setVisits(mockVisits)
    }
    //Loads the visits of the selected amka
    const amkaLoad = ()=>{
      setAmkaDialogOpen(true)
    }





    return(
      <Grid
      container
      direction="row"
      justifyContent="space-around"
      alignItems="center"
      spacing={1}
      >
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <Tooltip
          title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography  variant='h6' color="inherit">Επισκέψεις σήμερα</Typography>
              <Typography variant='subtitle2' color="inherit">Πατώντας το εικονίδιο ημερομηνίας, θα δείτε στον πίνακα επισκεψών τις επισκέψεις που ολοκληρώσατε σήμερα.</Typography>
          </React.Fragment>
          :''} 
          >
            <IconButton className="visitsToday" color={visits.length===5  ? "primary":"default"} onClick={todayLoad}>
              <Today/>
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <Tooltip
          title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography  variant='h6' color="inherit">Επισκέψεις μήνα</Typography>
              <Typography variant='subtitle2' color="inherit">Πατώντας το εικονίδιο μήνα, θα δείτε στον πίνακα επισκεψών τις επισκέψεις σας που ολοκληρώσατε στον τρέχων μήνα.</Typography>
          </React.Fragment>
          :''} 
          >
            <IconButton className="visitsMonth" color={ visits.length===10 ? "primary":"default"} onClick={monthLoad}>
              <DateRange/>
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <Tooltip
          title= {!helpActivatedTooltips ?
          <React.Fragment>
              <Typography  variant='h6' color="inherit">Αναζήτηση επισκέψεων</Typography>
              <Typography variant='subtitle2' color="inherit">Για να δείτε όλες τις επισκέψεις ενός ασθενή, κάντε κλικ στο εικονίδιο . Η αναζήτηση πραγματοποιείται μέσω του ΑΜΚΑ</Typography>
          </React.Fragment>
          :''} 
          >
            <IconButton className="visitsPatient" color={amkaDialogOpen? "primary":"default"} onClick={amkaLoad}>
              <AccountBox/>
            </IconButton>
          </Tooltip> 
        </Grid>
      </Grid>
    )
  }
  /*
    Component that shows the completed visits of the doctor (list form).
    Renders a row list (grid) and a Pagination 
  */
  const VisitsList = () => {

    
    //HelpActivatedContext data the tooltips show condition
    const [helpActivatedTooltips, setHelpActivatedTooltips] = useContext(HelpActivatedContext)



  

    
    /*
      Component that renders every single visit
      Renders a Dialog that represents the visit (every visit can be cancelled, printed, or included in quota)
      Every visit contains the prescription and referrals. (every prescription and referral can be cancelled, printed, or sent again to the patient)
      Every prescription and referral can be extended to present the coresponding medicines and tests
    */
    const Visit = (props)=>{


      //Opens / Closes the VisitInfo Component
      const [open, setOpen] = useState({
        status:false,
        visitInfo:null
      })
      //Stores the the number of prescriptions and referrals in the visit
      const [visitActions, setVsitActions] = useState({
        prescriptionsNumber:props.x.Prescriptions.length,
        referralsNumber:props.x.Referrals.length
      })




      /*
        Component that shows the full information of the visit (prescriptions and referrals)
        Renders a dialog
      */
      const VisitInfo = () =>{
   

        //CSS
        const useStyles = makeStyles({
          icon:{
            fontSize: 40, 
            color:'#5c6bc0'
          },
          iconRefferal:{
            fontSize: 40, 
            color:'#9575CD'
          },
          iconSmall:{
            fontSize: 40, 
            color:'#b0bec5',
          },
          expansionPanel:{
            backgroundColor:'#eceff1'
          },
          marginTop:{
            marginTop:'4rem'
          }
        })
        const classes = useStyles()

        const closeDialog = ()=>{
          setOpen({
            status:false,
            visitInfo:null
          })
        }


      

        /*
          Component that shows when there is no prescription in the visit
          Renders an accordion
        */
        const NoPrescriptions = ()=>{

          return(
            <Accordion className={classes.expansionPanel} elevation={0} >
              <AccordionSummary expandIcon={<ExpandMore/>} > 
                <Grid 
                container
                direction="row"
                justifyContent="space-around"
                alignItems="center"
                spacing={2} 
                >
                  <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
                    <FaFilePrescription className={classes.icon}/>
                  </Grid>
                  <Grid item xs={12} sm={10} md={10} lg={10} xl={10}>
                    <Typography variant="h6" color="textSecondary" >
                      Καμία συνταγή ...
                    </Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
            </Accordion>
          )
        }
        /*
          Component that shows the prescription information (medicines, cancel/print/send prescription)
          Renders an accordion
        */
        const Prescriptions = () => {

          //Holds the prescriptions info
          const [prescriptionsInfo, setPrescriptionsInfo] = useState(open.visitInfo.Prescriptions)

          const Prescription = (props) => {

            const y = props.props

            //Delete the sent prescription and update Dexie states and refs
            const cancelPrescription= async (x)=>{
              setDemoMessage({
                status:true,
                severity:"info",
                description:"το κουμπί αυτό θα ακυρώσει την συνταγή."
              })
            }
            //Print the sent prescription
            async function printPrescription(x) {
              setDemoMessage({
                status:true,
                severity:"info",
                description:"το κουμπί αυτό θα εκτυπώσει την συνταγή."
              })
            }
            //Send the sent prescription to the patient via sms
            const sendPrescriptionSms=async (x)=>{
              setDemoMessage({
                status:true,
                severity:"info",
                description:"το κουμπί αυτό θα ξαναστείλει την άυλη συνταγή."
              })
            }

        
  
            return(    
             
              <Accordion className="visitPrescriptions" style={{backgroundColor:'#eceff1'}} key={y.Prescription_Barcode} >
                
                  <AccordionSummary  expandIcon={<ExpandMore/>}  key={y.Prescription_Barcode} >
                  <Tooltip
                  title= {!helpActivatedTooltips ?
                  <React.Fragment>
                      <Typography  variant='h6' color="inherit">Συνταγή</Typography>
                      <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στη συνταγή, μπορείτε να δείτε τα φάρμακα που περιλαμβάνει, το δοσολογικό σχήμα και τη διάγνωση που χρησιμοποιήθηκε. Επιπλέον, μπορείτε να την ακυρώσετε, να την εκτυπώσετε ή να την ξαναστείλετε στον ασθενή.</Typography>
                  </React.Fragment>
                  :''} 
                  >
                    <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    >
                      
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <Badge overlap='rectangular' badgeContent={y.Treatment.length} color="secondary">
                          <FaFilePrescription className={classes.icon}/> 
                        </Badge>
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <Typography color='textSecondary' variant='caption'>
                          Barcode συνταγής : 
                        </Typography>
                        <Typography color='textPrimary' variant='subtitle2'>
                          {y.Prescription_Barcode}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <Typography color='textSecondary' variant='caption'>
                          Κατάσταση συνταγής : 
                        </Typography>
                        <Typography color='textPrimary' variant='subtitle2'>
                          {y.Prescription_Status} 
                        </Typography>
                      </Grid>

                      

                    </Grid>
                  </Tooltip>

                  </AccordionSummary>
                <Divider variant='middle'/>
                <Divider variant='middle'/> 
                <Divider variant='middle'/>       

                <AccordionDetails  key={y.Prescription_Barcode} >    
                    <List>
                      {y.Treatment.length===0 ? 
                      <Typography variant="subtitle2" color="textSecondary" >
                        Κανένα φαρμακευτικό σκεύασμα στη συνταγή ...
                      </Typography>
                      : 
                      y.Treatment.map((z,index) => (
                        <div key={index}  >
                          <Grid 
                          container 
                          direction="row" 
                          justifyContent="space-between" 
                          alignItems="center" 
                          >

                          <Grid item xs={12} >  
                            <ListItem key={z.index} >
                              <ListItemText secondary ={'Φαρμακευτικό σκεύασμα: '} primaryTypographyProps={{variant:"h6" ,color:"textPrimary"}} primary={z.Medication}  secondaryTypographyProps={{variant:"caption", color:"textSecondary"}}/> 
                            </ListItem>
                          </Grid>
                          
                          <Grid item xs>  
                            <ListItem > 
                              <ListItemText secondary ={'Εμβαλάγια: '} primaryTypographyProps={{variant:"h6" ,color:"textPrimary"}} primary={`${z.Quantity_Value}` }  secondaryTypographyProps={{variant:"caption", color:"textSecondary"}}/> 
                            </ListItem>
                          </Grid>
                          <Grid item xs> 
                            <ListItem >   
                              <ListItemText secondary ={'Δόση: '} primaryTypographyProps={{variant:"h6" ,color:"textPrimary"}} primary={`${z.Dose_Value}`}   secondaryTypographyProps={{variant:"caption", color:"textSecondary"}}/>  
                            </ListItem>
                          </Grid>
                          <Grid item xs > 
                            <ListItem >   
                              <ListItemText secondary ={'Φαρμακοτεχνική μορφή: '}primaryTypographyProps={{variant:"subtitle2" ,color:"textPrimary"}} primary={`${z.Dose_Unit}`} secondaryTypographyProps={{variant:"caption", color:"textSecondary"}}/> 
                            </ListItem>
                          </Grid>
                          <Grid item xs> 
                            <ListItem >
                              <ListItemText secondary ={'Δοσολογικό σχήμα: '} primaryTypographyProps={{variant:"subtitle2" ,color:"textPrimary"}} primary={`${z.Frequency}  για ${z.Duration_Value} ημέρες.`}  secondaryTypographyProps={{variant:"caption", color:"textSecondary"}}/> 
                            </ListItem>
                          </Grid>
                          {z.Diagnosis.map(xo=>(
                            <Grid key={xo.length} item xs={12}>  
                            <ListItem > 
                              <ListItemText secondary ={'Διάγνωση: '} primaryTypographyProps={{variant:"subtitle2" ,color:"textPrimary"}} primary={`${xo}` }  secondaryTypographyProps={{variant:"caption", color:"textSecondary"}}/> 
                            </ListItem>
                            </Grid>             
                          ))}
                          </Grid>
                        <Divider light={true}/>
                      </div>
                      ))}
                    </List>
                </AccordionDetails>

                <AccordionActions>
                
                  
                  <>
                    <Tooltip
                    title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography variant='subtitle2' color="inherit">Ακύρωση συνταγής</Typography>
                    </React.Fragment>
                    :''} 
                    >
                      <span>
                        <IconButton className="visitPrescriptions"onClick={(event) =>{ event.stopPropagation() ; cancelPrescription(y)}}>
                          <Delete fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip
                    title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography variant='subtitle2' color="inherit">Εκτύπωση συνταγής</Typography>
                    </React.Fragment>
                    :''} 
                    >
                      <span>
                        <IconButton className="visitPrescriptions" onClick={(event)=>{event.stopPropagation() ; printPrescription(y) }}>
                          <Print  fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip
                    title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography variant='subtitle2' color="inherit">Αποστολή αύλης συνταγής</Typography>
                    </React.Fragment>
                    :''} 
                    >
                      <span>
                        <IconButton className="visitPrescriptions" onClick={(event)=>{event.stopPropagation() ; sendPrescriptionSms(y) }}>
                          <Send  fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </>
                </AccordionActions>

              </Accordion>

            )
          
          }

          return(    
            prescriptionsInfo.map( y => 
              <Prescription props={y} key={y.Prescription_Barcode} />
            )
          )
        
        }
        /*
          Component that shows when there in no referral in the visit
          Renders an accordion
        */
        const NoReferrals = ()=>{
          return(
              <Accordion className={classes.expansionPanel} elevation={0} >
                <AccordionSummary className="PrescriptionTitle" expandIcon={<ExpandMore/>} >

                  <Grid
                  container
                  direction="row"
                  justifyContent="space-around"
                  alignItems="center"
                  spacing={2}
                  >
                    <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
                      <FaNotesMedical className={classes.iconRefferal}/>
                    </Grid>

                    <Grid item xs={12} sm={10} md={10} lg={10} xl={10}>
                      <Typography variant="h6" color="textSecondary" >
                        Κανένα παραπεμπτικό ...
                      </Typography>
                    </Grid>

                  </Grid>
                </AccordionSummary>
              </Accordion>
          )
        }
        /*
          Component that shows the referral information (tests, cancel/print/send prescription)
          Renders an accordion
        */
        const Referrals = ()=>{

          //Holds the Referral info
          const [referralsInfo, setReferralsInfo] = useState(open.visitInfo.Referrals)


          const Referral = (props)=>{

            const y = props.props 

            console.log(y)
  
            //Delete the sent prescription and update Dexie states and refs
            const cancelReferral = async (x)=>{
              setDemoMessage({
                status:true,
                severity:"info",
                description:"το κουμπί αυτό θα ακυρώσει το παραπεμπτικό."
              })
            }
            //Print the sent prescription
            async function printReferral(x) {
              setDemoMessage({
                status:true,
                severity:"info",
                description:"το κουμπί αυτό θα εκτυπώσει το παραπεμπτικό."
              })
            }
            //Send the sent prescription to the patient via sms
            const sendReferralSms=async (x)=>{
              setDemoMessage({
                status:true,
                severity:"info",
                description:"το κουμπί αυτό θα ξαναστείλει το άυλο παραπεμπτικό."
              })
            }
  
  
  
  
            return(

              <Accordion className="visitsReferals" style={{backgroundColor:'#eceff1'}} key={y.Referral_Barcode} >
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography  variant='h6' color="inherit">Παραπεμπτικό</Typography>
                    <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στο παραπεμπτιμκό, μπορείτε να δείτε τις εξετάσεις που καταχωρήθηκαν και τη διάγνωση που χρησιμοποιήθηκε. Μπορείτε επίσης να το ακυρώσετε, να το εκτυπώσετε ή να το ξαναστείλετε στον ασθενή.</Typography>
                </React.Fragment>
                :''} 
                >
                  <AccordionSummary  expandIcon={<ExpandMore/>}  key={y.Referral_Barcode} >
                    <Grid
                    container
                    direction="row"
                    alignItems="center"
                    >

                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <Badge overlap='rectangular' badgeContent={y.Test.length} color="secondary">
                          <FaNotesMedical className={classes.iconRefferal}/>
                        </Badge>
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <Typography color='textSecondary' variant='caption'>
                          Barcode παραπ/κού : 
                        </Typography>
                        <Typography color='textPrimary' variant='subtitle2'>
                          {y.Referral_Barcode} 
                        </Typography>
                      </Grid>
                      
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <Typography color='textSecondary' variant='caption'>
                          Κατάσταση παραπ/κού : 
                        </Typography>
                        <Typography color='textPrimary' variant='subtitle2'>
                          {y.Referral_Status} 
                        </Typography>
                      </Grid>
                    </Grid>
                  </AccordionSummary>
                </Tooltip>
                <Divider variant='middle'/>
                <Divider variant='middle'/> 
                <Divider variant='middle'/>  

                <AccordionDetails  key={y.Referral_Barcode} >
                  <Grid container> 
                    <Grid item xs={12}> 
                      <List>
                      {y.Test.length===0 ? 
                        <Typography variant="subtitle2" color="textSecondary" >
                          Καμία εξέταση στο παραπεμπτικό ...
                        </Typography>
                        : 
                        y.Test.map((z,index) => (
                        <div key={index} >
                          <Grid 
                          container 
                          direction="row" 
                          justifyContent="space-between" 
                          alignItems="center" 
                          >

                            <Grid item xs={12} >  
                              <ListItem >
                                <ListItemText secondary ={'Εξέταση: '} primaryTypographyProps={{variant:"h6" ,color:"textPrimary"}} primary={`${z.Procedure}` }  secondaryTypographyProps={{variant:"caption", color:"textSecondary"}}/> 
                              </ListItem>
                            </Grid>

                            <Grid item xs>  
                            <ListItem > 
                              <ListItemText secondary ={'Διάγνωση: '} primaryTypographyProps={{variant:"subtitle2" ,color:"textPrimary"}} primary={`${z.Diagnosis}` }  secondaryTypographyProps={{variant:"caption", color:"textSecondary"}}/> 
                            </ListItem>
                            </Grid>       

                          </Grid>
                        <Divider/>
                      </div>
                      ))}
                      </List>
                    </Grid>
                  </Grid>
                </AccordionDetails>

                <AccordionActions>
                 
                  <>
                    <Tooltip
                    title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography variant='subtitle2' color="inherit">Ακύρωση παραπεμπτικού</Typography>
                    </React.Fragment>
                    :''} 
                    >
                      <span>
                        <IconButton className="visitsReferals" disabled={y.Referral_Status!=='ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΟ' } onClick={(event) =>{ event.stopPropagation() ; cancelReferral(y)}}>
                          <Delete  fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip
                    title= {!helpActivatedTooltips ?
                    <React.Fragment>
                      <Typography variant='subtitle2' color="inherit">Εκτύπωση παραπεμπτικού</Typography>
                    </React.Fragment>
                    :''} 
                    >
                      <span>
                        <IconButton className="visitsReferals" onClick={(event)=>{event.stopPropagation() ; printReferral(y) }}>
                          <Print fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip
                    title= {!helpActivatedTooltips ?
                    <React.Fragment>
                        <Typography variant='subtitle2' color="inherit">Αποστολή αύλου παραπεμπτικού</Typography>
                    </React.Fragment>
                    :''} 
                    >
                      <span>
                        <IconButton className="visitsReferals"  onClick={(event)=>{event.stopPropagation() ; sendReferralSms(y)}}>
                          <Send fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </>
                  
                  
                </AccordionActions>


              </Accordion>        
              
            )
          }

          return(
            
            referralsInfo.map(y =>
              <Referral key={y.Referral_Barcode} props={y}/>
            )
            
          )
        }
      

        return(
          <>

            <Dialog fullWidth={true} maxWidth='md' open ={open.visitInfo!==null} scroll='body' onClose={closeDialog}>
              <DialogTitle>
                <Grid 
                container 
                justifyContent="space-between" 
                alignItems="flex-end" 
                >
                  <Grid item>
                    <Typography variant="h5">
                      <strong>{open.visitInfo.patientInfo.lastName + "    " + open.visitInfo.patientInfo.firstName}</strong> 
                    </Typography>
                    <Typography variant="subtitle2"  color="textSecondary">
                    {props.x.patientInfo.socialInsuranceShortName}
                    </Typography>
                    <Typography variant="subtitle2" color="textSecondary" >
                      {props.x.patientInfo.amka}  
                    </Typography>
  
                    <Typography variant="subtitle2" color="textSecondary">
                      {props.x.id}
                    </Typography>
                  </Grid>

                  <Grid item>
                  <Tooltip title="Κλείσιμο">
                    <IconButton aria-label="close"  onClick={closeDialog}>
                      <Close/>
                    </IconButton>
                    </Tooltip>
                  </Grid>

                </Grid>
              </DialogTitle>

              <DialogContent>
                {open.visitInfo.Prescriptions.length ? <Prescriptions/> : <NoPrescriptions/> }
                <div style={{marginTop:'4rem'}}></div>
                {open.visitInfo.Referrals.length ?  <Referrals/> : <NoReferrals/> }
                <div style={{marginTop:'4rem'}}></div>
              </DialogContent>   

            </Dialog>

          
          </>
        )
      }

      //Style visit component
      const useStyles = makeStyles((theme) => ({
        root: {
          width: "12rem",
          margin:"auto"
        },

        icon:{
          fontSize: "4rem",
          color:'#5c6bc0'
        },
        iconRefferal:{
          fontSize: "4rem",
          color:'#9575CD'
        },
        iconSimpleVisit:{
          fontSize: "4rem",
          color:'#9fa8da'
        },
        margin: {
          margin: "2rem" //theme.spacing.unit * 2
        },
        customBadgePrescription: {
          backgroundColor: "#5c6bc0",
          color: "white"
        },
        customBadgeReferral: {
          backgroundColor: "#9575CD",
          color: "white"
        }
      }))
      const classes = useStyles();

      const handleCancelVisit= () =>{
        setDemoMessage({
          status:true,
          severity:"info",
          description:"το κουμπί αυτό θα ακυρώσει την επίσκεψη."
        })
      }
      const printVisit = () =>{
        setDemoMessage({
          status:true,
          severity:"info",
          description:"το κουμπί αυτό θα εκτυπώσει την επίσκεψη."
        })
      }
      const changeQuota  = () =>{
        setDemoMessage({
          status:true,
          severity:"info",
          description:"το κουμπί αυτό θα θα χρεώσει την επίσκεψη στον ΕΟΠΥΥ."
        })
      }



      return(
        <>   

        
        
 
          {open.status && <VisitInfo/>}

          <Card className="visitInformation"  style={{ width: "12rem",margin:"auto"}}>
            <Tooltip
            title= {!helpActivatedTooltips ?
            <React.Fragment>
                <Typography  variant='h6' color="inherit">Καρτέλα επίσκεψης</Typography>
                <Typography variant='subtitle2' color="inherit">Σε κάθε επίσκεψη, θα δείτε το όνομα του ασθενούς, την ώρα έναρξης της επίσκεψης και την κατάσταση της επίσκεψης. Εάν κάνετε κλικ στην επίσκεψη, θα δείτε περισσότερες πληροφορίες, όπως τις συνταγές και τα παραπεμπτικά που έχουν καταχωρηθεί.</Typography>
            </React.Fragment>
            :''} 
            >
              <CardActionArea className="visitsFullInfo" onClick={ ()=>setOpen({ status:true,visitInfo:props.x}) }>
                <CardContent>
                  <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  >
                    {visitActions.prescriptionsNumber!==0 &&
                    <Grid item xs={6}>
                      <Badge overlap='rectangular' classes={{ badge: classes.customBadgePrescription }}  badgeContent={visitActions.prescriptionsNumber} >
                        <FaFilePrescription  className={classes.icon}/>
                      </Badge>                         
                    </Grid>}

                    {visitActions.referralsNumber!==0 &&
                    <Grid item xs={6}>
                      <Badge overlap='rectangular' classes={{ badge: classes.customBadgeReferral }}  badgeContent={visitActions.referralsNumber} >
                        <FaNotesMedical  className={classes.iconRefferal}/>  
                      </Badge>    
                    </Grid>}

                    {visitActions.referralsNumber===0 && visitActions.prescriptionsNumber===0 &&
                    <Grid item xs={12}>
                      <FaCommentMedical  className={classes.iconSimpleVisit}/>                   
                    </Grid>}
                  </Grid>

                  <br></br>
                  <Divider/>
                  <br></br>

                  <Typography variant="subtitle2" color="textSecondary" component="p">
                    <strong> {props.x.patientInfo.lastName + " " + props.x.patientInfo.firstName } </strong>
                  </Typography>
                  <Typography variant="subtitle2" color="textSecondary" component="p">
                    {props.x.startDate}
                  </Typography>
                  <Typography variant="subtitle2" color="textSecondary" component="p">
                    {props.x.status.status}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Tooltip>
            <CardActions className="visitActions">
              <Grid
                container
                direction="row"
                justifyContent="space-around"
                alignItems="center"
              >
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography  variant='h6' color="inherit">Ακύρωση επίσκεψης</Typography>
                    <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στο εικονίδιο, θα ακυρώσετε την επίσκεψη, καθώς και όλες τις συνταγές και παραπεμπτικά που έχετε καταχωρήσει σε αυτή.</Typography>
                </React.Fragment>
                :''} 
                >
                <IconButton onClick={handleCancelVisit}>
                  <Delete fontSize='small' />
                </IconButton> 
                </Tooltip>
                
                
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography  variant='h6' color="inherit">Εκτύπωση επίσκεψης</Typography>
                    <Typography variant='subtitle2' color="inherit">Κάνοντας κλικ στο εικονίδιο, εκτυπώνετε την επίσκεψη,</Typography>
                </React.Fragment>
                :''} 
                >
                <IconButton  onClick={printVisit}>
                  <Print fontSize='small' />
                </IconButton> 
                </Tooltip>

             
                <Tooltip
                title= {!helpActivatedTooltips ?
                <React.Fragment>
                    <Typography  variant='h6' color="inherit">{props.x.inQuota ? "Επίσκεψη χρεωμένη" : "Επίσκεψη έχει εξαιρεθεί"} </Typography>
                    <Typography variant='subtitle2' color="inherit">Κλικάροντας στο εικονίδιο, η επίσκεψη είτε χρεώνεται είτε εξαιρείται από τη χρέωση στον ΕΟΠΠΥ.</Typography>
                </React.Fragment>
                :''} 
                >
                  <Checkbox 
                    size="small"
                    checked={props.x.inQuota}
                    onChange={()=>changeQuota()}
                    color='primary'
                  />
                </Tooltip>
               

              </Grid>
            </CardActions>

         

          </Card>

        </>        
      )
    }
    
    //CSS
    const useStyles = makeStyles({

      pagination:{
        marginTop:"1rem",
        marginBottom:"1rem",
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        bottom: '0',
        right:'0'
      }
    })
    const classes = useStyles();


    return(

      <Grid 
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      style={visits.length === 0 ? {backgroundImage: `url(${MedicinesAndPills})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      minHeight:'70vh',
      width:'auto',} : 
      {
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      minHeight:'70vh',
      width:'auto',}}
      >


          {visits.map(x => (
            <Grid key={x.id} item xs >
              <Visit x={x}/>
            </Grid>
          ))}  

      
      

      </Grid>

    )
  }

  //CSS
  const useStyles = makeStyles({
    root: {
      backgroundColor: "#f5f5f5",
      minHeight:"78vh",
      
    },
    visitList:{
      marginBottom: "1rem"
    },
    header:{
      minHeight: "4rem"
    }
  })
  const classes = useStyles()


  return(
    

    

   

      <> 

        <AmkaSearch/> 

        <Container  
        maxWidth={false}
        className="visitsBox"
        style={{backgroundColor: "#f5f5f5",minHeight:"78vh"}}
        > 

          <Grid 
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          >

            <Grid className={classes.header} item xs={8} sm={10} md={10} lg={11} xl={11}>
              <Typography variant='h6' color='textSecondary'>
                {`Επισκέψεις ${(visits.length===5 || visits.length===1) ? `σήμερα` : `μήνα`}`}
              </Typography>
              <Typography variant='subtitle2' color='textSecondary'>
                {visits.length} επισκέψεις.
              </Typography>
            </Grid>

            <Grid item xs={4} sm={2} md={2} lg={1} xl={1}>
              <VisitsFilter/>
            </Grid>

          </Grid>

          <Divider variant='fullWidth' className={classes.visitList}/>
            
          <VisitsList/>
      
        </Container>

      </>


  )
}
/*
  Component for searching the patient to start the visit
  Renders a textfield or a button in case of active visit
*/
const PatientSearch = () =>{


  const [searchAmka, setsearchAmka] = useState("")
  
  //HelpActivatedContext data the helper tooltips show condition
  const [helpActivatedTooltips, setHelpActivatedTooltips] = useContext(HelpActivatedContext)
 



  const navigate = useNavigate()
  let history = useLocation()




 










  //Get patient information
  async function patientSearch() {
    navigate("/PatientPage")
  }
  //Update the input and check for errors (input length and accept ONLY numbers)
  const onInputChange = (event)=> {
    setsearchAmka(event.target.value)
  }


  


  //CSS
  const useStyles = makeStyles({
    input : {
      fontSize:'1.5rem',
      color:'#616161',
      backgroundColor: "#f5f5f5",
      letterSpacing: '5px',
      fontWeight: 'bold',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      borderRadius: '10px',
    },
    inputText : {
      fontSize:'1.5rem',
      color:'#616161',
      backgroundColor: "#f5f5f5",
      letterSpacing: '5px',
      fontWeight: 'bold',
      marginLeft: '1rem'
    },
    root:{
      height:'4rem'
    },
    icon:{
      marginRight:'1rem'
    }
   
  })
  const classes = useStyles()






  



  
  
  return(
  

   
 
        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography  variant='h6' color="inherit">Αναζήτηση ασθενή</Typography>
          <Typography variant='subtitle2' color="inherit"> Εισάγετε τον ΑΜΚΑ του ασθενούς που θέλετε να καταχωρίσετε για την επίσκεψη και πατήστε "Enter" για να πραγματοποιηθεί η αναζήτηση.</Typography>
        </React.Fragment> 
        :''} 
        >
          <TextField
          className={classes.input}
          variant='standard'
          fullWidth
          autoComplete="off"
          placeholder="ΑΜΚΑ"
          value={searchAmka}
          onChange={onInputChange}
          onKeyPress={(event) => {
            if(event.key === 'Enter' ){ patientSearch() }
          }}
          InputProps={{
          classes: {
            input: classes.inputText,
            root : classes.root,
          },
          disableUnderline: true,
          endAdornment:
            <InputAdornment position="end">
              <Tooltip  title= 'Αναζήτηση' >
              <IconButton className={classes.icon} onClick={()=>{ patientSearch() }} color="default" edge="end" aria-label="search">
                  <Search  fontSize="large"/> 
              </IconButton>
              </Tooltip>
            </InputAdornment>
          }}
          />
         </Tooltip>
        
  
       
     
  )
}
//A dialog component that presents the user information like :1) prescription unit, 2)Personal info, 3)Prescription statistics
const DocInformation = () => {

  //Open / close the Help Dialog
  const [openHelpDialog, setOpenHelpDialog] = useState(false)
  const setDemoMessage = useDemoStore(state => state.setDemoMessage)
 
  //Joyride data (helper steps)
  const [steps, setSteps] = useContext(HelperStepsContext)
  const [anchorEl, setAnchorEl] = useState(null);
  //HelpActivatedContext data the helper tooltips show condition
  const [helpActivatedTooltips, setHelpActivatedTooltips] = useContext(HelpActivatedContext)

  

  //Close the drawer
  const handleClose = () => {
    setAnchorEl(null)
  }
  //Open the drawer
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  }
  
 



  //Activate the "Write Prescription" help
  const helpDialogOpen= () => {
    setAnchorEl(null)
    setOpenHelpDialog(true)
    setSteps(prev=>{return{...prev, status:false}})
  }


 

 const handleDemo = ()=>{
  setDemoMessage({
    status:true,
    severity:"info",
    description:"το κουμπί αυτό προβάλλει τις αντίστοιχες πληροφορίες.",

  })
 }


 //Component to help the user get familiar with the app
 const Help = () => {
 
  const [autoShow, setAutoShow] = useState(JSON.parse(localStorage.getItem('autohelpDisable')))
  const [autoShowTooltips, setAutoShowTooltips] = useState(JSON.parse(localStorage.getItem('autohelpDisableTooltips')))
  const [errorContactInfo, setErrorContactInfo] = useState(JSON.parse(localStorage.getItem('errorContactInfo')))
  //HelpActivatedContext data the helper tooltips show condition
  const [helpActivatedTooltips, setHelpActivatedTooltips] = useContext(HelpActivatedContext)



  //Close the dialog and abort the "dhpcInformation" call
  function closeHelpDialog(){
    //Close dialog
    setOpenHelpDialog(false)
    setHelpActivatedTooltips(autoShowTooltips)
  }
  //Disables the auto open of the "helper" Dialog
  function disableAutoShow(){
    localStorage.setItem('autohelpDisable', !autoShow);
    setAutoShow(prev=>!prev)
  }
  //Disables the auto open of the "helper" Dialog
  function disableAutoShowTooltips(){
    localStorage.setItem('autohelpDisableTooltips', !autoShowTooltips);
    setAutoShowTooltips(prev=>!prev)
  }



  const help = [
    {
      index:1,
      prerequisite:"",
      description: 'Καταχώρηση συνταγής',
      info:{
        status:true,
        data:[
          {
            header: 'Αναζήτηση ασθενή',
            target: 'amkaSearch',
            content: 'Παρακαλώ εισάγετε το ΑΜΚΑ του ασθενή που θα θέλατε να καταχωρήσετε στην επίσκεψη. Κάντε κλικ στο κουμπί αναζήτησης ή πατήστε Enter.',
            index :1,
            page:"/MainPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Άνοιγμα επίσκεψης',
            target: 'visitReason',
            content: 'Παρακαλώ εισάγετε τον λόγο επίσκεψής του ασθενή ή επιλέξτε μία από τις επιλογές που δίνονται παρακάτω. Στη συνέχεια, πατήστε "ΑΝΟΙΓΜΑ" για να ξεκινήσετε την επίσκεψη.',
            index :2,
            page:"/PatientPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Επιλογή σκευάσματος',
            target: 'selectMedicine',
            content: 'Κάντε κλικ στο κείμενο του φαρμακευτικού σκευάσματος. Μπορείτε να επιλέξετε ένα σκεύασμα από την παρεχόμενη λίστα ή να το αναζητήσετε. Στη λίστα, προτεινόμενα φάρμακα για τον ασθενή (σύμβολο: Ανθρωπάκι) εμφανίζονται πρώτα, ενώ μετά εμφανίζονται τα φάρμακα που συνήθως χρησιμοποιείτε (σύμβολο: Ρολόι).Μπορείτε να διαγράψετε το επιλεγμένο φάρμακο κάνοντας κλικ στο σύμβολο "X".',
            index :3,
            page:"/PrescriptionPage",
            initialStep:true,
            finalStep:false
          },
          {
            header: 'Διάγνωση',
            target: 'diagnosisSelect',
            content: `Αναζητήστε τη διάγνωση ή την επιλέξτε από τη λίστα. Οι διαγνώσεις που σχετίζονται με το φάρμακο (συμβολο φαρμακο) εμφανίζονται πρώτες,  και στη συνέχεια εμφανίζονται οι συχνά χρησιμοποιούμενες διαγνώσεις σας. Για να διαγράψετε μια επιλεγμένη διάγνωση, επιλέξτε "Χ". Οι διαγνώσεις συνήθως είναι προσυμπληρωμένες βάσει ενός αλγορίθμου μάθησης.`,
            index :4,
            page:"/PrescriptionPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Δοσολογικό σχήμα',
            target: 'dosageSchema',
            content: `Παρακαλώ συμπληρώστε το δοσολογικό σχήμα (δόση, συχνότητα, ημέρες)και την ποσότητα των εμβαλαγίων που επιθυμείτε να συνταγογραφήσετε. Το δοσολογικό σχήμα συνήθως συμπληρώνεται αυτόματα με βάση έναν αλγόριθμο μάθησης.`,
            index :5,
            page:"/PrescriptionPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Επαναληψιμότητα και συμμετοχή',
            target: 'repeteability',
            content: `Επιλέξτε την επαναληψιμότητα της συνταγης και ποια θα είναι η συμμετοχή του ασθενούς.Η συμμετοχή προσδιορίζεται με βάση τα χαρακτηριστικά του ασθενούς, τον ασφαλιστικό του φορέα και το επιλεγμένο φάρμακο . Σε κάθε περίπτωση, θα πρέπει να γίνεται επανέλεγχος του ποσοστού συμμετοχής.`,
            index :6,
            page:"/PrescriptionPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Θεραπευτικά πρωτόκολλα',
            target: 'TP',
            content: `Σε περίπτωση που χρειάζεται θεραπευτικό πρωτόκολο, το σύστημα μπορεί να το δημιουργήσει αυτόματα ή να σας καθοδηγήσει στη δημιουργία του. 
            Αν είναι πράσινο, τότε απαιτείται και θα διεκπεραιωθεί αυτοματα. 
            Αν είναι κόκκινο, τότε θα πρέπει να το εισαγάγετε εσείς. 
            Για να το εισάγετε, επιλέγετε "ΟΔΗΓΟΣ ΘΠ" και στη συνέχεια "ΚΑΤΑΧΩΡΗΣΗ ΘΠ".`,
            index :7,
            page:"/PrescriptionPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Πληροφορίες',
            target: 'prescriptionInfo',
            content: `Επιλέγοντας το κουμπί "Πληροφορίες Φαρμάκου" βλέπετε βασικές πληροφορίες για το φάρμακο.
            Με το κουμπί "ΘΠ Επισκέψεις" μπορείτε να ελέγξετε τα θεραπευτικά πρωτόκολλα που έχετε εισαγάγει στην επίσκεψη. 
            Με το κουμπί "ΙΦΕΤ" μπορείτε να εισάγετε φάρμακα μέσω της διαδικασίας ΙΦΕΤ.
            Επιλέγοντας το κουμπί "Γνωματεύση" μπορείτε να προσθέσετε γνωμάτευση στη συνταγή.`,
            index :8,
            page:"/PrescriptionPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Καταχώρηση φαρμάκου',
            target: 'addMedicine',
            content: 'Αφού ελέγξετε τη διάγνωση, το δοσολογικό σχήμα και τη συμμετοχή του ασθενή, πατήστε το κουμπί "ΠΡΟΣΘΗΚΗ" για να εισάγετε το φάρμακο στην αντίστοιχη συνταγή.',
            index :9,
            page:"/PrescriptionPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Καταχώρηση συνταγών',
            target: 'prescriptionPresentationBeforeSend',
            content: `Τα φάρμακα αυτόματα προσθέτονται σε συνταγές με βάση τα χαρακτηριστικά τους.  Μπορείτε να προσθέσετε όσα φάρμακα χρειάζεται ο ασθενής και να στείλετε τη συνταγή πατώντας "ΑΠΟΣΤΟΛΗ" (Σύμβολο: "μικρό βέλος που δείχνει προς τα δεξιά)".Κάνοντας κλικ στο φάρμακο της συνταγής, μπορείτε να δείτε αναλυτικές πληροφορίες για τη συνταγογράφηση του. Αν θέλετε να αφαιρέσετε ένα φάρμακο  από την συνταγή, επιλέξτε το σύμβολο "Χ".`,
            index :10,
            page:"/PrescriptionPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Διαχείρηση συνταγών',
            target: 'prescriptionPresentationAfterSend',
            content: `Μπορείτε να στείλετε τη συνταγή στον ασθενή (Σύμβολο: μήνυμα), να την εκτυπώσετε (Σύμβολο: εκτυπωτής) ή να την απορρίψετε (Σύμβολο: κάδος). `,
            index :11,
            page:"/PrescriptionPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Ακύρωση επίσκεψης',
            target: 'cancel',
            content: `Όταν επιλέγετε "ΑΚΥΡΩΣΗ" ακυρώνετε την επίσκεψη καθώς και όλες τις συνταγές και παραπεμπτικά που έχετε εισάγει σε αυτή. Μετά την ακύρωση επιστρέφετε στην αρχική σελίδα. `,
            index :12,
            page:"all",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Ολοκλήρωση επίσκεψης',
            target: 'close',
            content: `Όταν επιλέγετε "ΚΛΕΙΣΙΜΟ", ολοκληρώνετε την επίσκεψη και επιστρέφετε στην αρχική σελίδα. `,
            index :13,
            page:"all",
            initialStep:false,
            finalStep:true
          }
        ]
      }
    },
    {
      index:2,
      description: 'Καταχώρηση παραπεμπτικού',
      info:{
        status:true,
        data:[
          {
            header: 'Αναζήτηση ασθενή',
            target: 'amkaSearch',
            content: 'Παρακαλώ εισάγετε το ΑΜΚΑ του ασθενή που θα θέλατε να καταχωρήσετε στην επίσκεψη. Κάντε κλικ στο κουμπί αναζήτησης ή πατήστε Enter.',
            index :1,
            page:"/MainPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Άνοιγμα επίσκεψης',
            target: 'visitReason',
            content: 'Παρακαλώ εισάγετε τον λόγο επίσκεψής του ασθενή ή επιλέξτε μία από τις επιλογές που δίνονται παρακάτω. Στη συνέχεια, πατήστε "ΑΝΟΙΓΜΑ" για να ξεκινήσετε την επίσκεψη.',
            index :2,
            page:"/PatientPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Εξετάσεις',
            target: 'selectExamsPage',
            content: 'Κάντε κλικ στο κουμπί "ΕΞΕΤΑΣΕΙΣ" για να μεταφερθείτε στην σελίδα των εξετάσεων.',
            index :3,
            page:"/PrescriptionPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Επιλογή εξετάσεων',
            target: 'examsSelect',
            content: `Κάντε κλικ στο κείμενο της εξέτασης. Μπορείτε να επιλέξετε μια εξέταση από την παρεχόμενη λίστα ή να την αναζητήσετε. Στη λίστα, προτείνονται συχνά χρησιμοποιούμενες εξετάσεις.Μπορείτε να διαγράψετε την επιλεγμένη εξέταση κάνοντας κλικ στο σύμβολο "X".`,
            index :4,
            page:"/ReferralPage",
            initialStep:true ,
            finalStep:false
          },
          {
            header: 'Διάγνωση',
            target: 'diagnosisSelect',
            content: `Αναζητήστε τη διάγνωση ή την επιλέξτε από τη λίστα. Όταν επιλέγετε το κείμενο αναζήτησης των διαγνώσεων, εμφανίζονται οι διαγνώσεις που σχετίζονται με την εξέταση (σύμβολο σύριγγα). Μπορείτε να διαγράψετε την επιλεγμένη διάγνωση κάνοντας κλικ στο σύμβολο "X".`,
            index :5,
            page:"/ReferralPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: ' Συμπληρωματικά στοιχεία εξετάσεων',
            target: 'exameExtraInput',
            content: `Το σχόλια παραπεμπτικού, η ποσότητα και ο λόγος παραπομπής ειναι προσυμπληρωμένα.Σε περίπτωση μηδενικής συμμετοχής του ασθενή επιλέξτε την αιτιολογια`,
            index :6,
            page:"/ReferralPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Καταχώρηση εξέτασης',
            target: 'addExam',
            content: 'Πατήστε το κουμπί "ΠΡΟΣΘΗΚΗ" για να εισάγετε την εξέταση στον αντίστοιχο παραπεμπτικό.',
            index :7,
            page:"/ReferralPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Καταχώρηση παραπεμπτικού',
            target: 'referalPresentationBeforeSend',
            content: `Οι εξετάσεις αυτόματα καταχωρούνται σε παραπεμπτικά με βάση την κατηγορία στην οποία ανήκουν.  Μπορείτε να προσθέσετε όσες εξετάσεις χρειάζεται ο ασθενής και να στείλετε το παραπεμπτικό πατώντας "ΑΠΟΣΤΟΛΗ" (Σύμβολο: "μικρό βέλος που δείχνει προς τα δεξιά)".Κάνοντας κλικ στην εξέταση του παραπεμπτικού, μπορείτε να δείτε αναλυτικές πληροφορίες για την εξέταση. Αν θέλετε να αφαιρέσετε μια εξέταση από το παραπεμπτικό, επιλέξτε το σύμβολο "Χ".`,
            index :8,
            page:"/ReferralPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Διαχείρηση συνταγών',
            target: 'referalPresentationAfterSend',
            content: `Μπορείτε να στείλετε το παραπεμπτικό στον ασθενή (Σύμβολο: μήνυμα), να το εκτυπώσετε (Σύμβολο: εκτυπωτής) ή να το απορρίψετε (Σύμβολο: κάδος). `,
            index :9,
            page:"/ReferralPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Ακύρωση επίσκεψης',
            target: 'cancel',
            content: `Όταν επιλέγετε "ΑΚΥΡΩΣΗ" ακυρώνετε την επίσκεψη καθώς και όλες τις συνταγές και παραπεμπτικά που έχετε εισάγει σε αυτή. Μετά την ακύρωση επιστρέφετε στην αρχική σελίδα. `,
            index :10,
            page:"all",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Ολοκλήρωση επίσκεψης',
            target: 'close',
            content: `Όταν επιλέγετε "ΚΛΕΙΣΙΜΟ", ολοκληρώνετε την επίσκεψη και επιστρέφετε στην αρχική σελίδα. `,
            index :11,
            page:"all",
            initialStep:false,
            finalStep:true
          }
        ]
      }
    },
    {
      index:3,
      prerequisite:"",
      description: 'Χρήση "Πακέτου εξετάσεων" στα παραπεμπτικά',
      info:{
        status:true,
        data:[
          {
            header: 'Αναζήτηση ασθενή',
            target: 'amkaSearch',
            content: 'Παρακαλώ εισάγετε το ΑΜΚΑ του ασθενή που θα θέλατε να καταχωρήσετε στην επίσκεψη. Κάντε κλικ στο κουμπί αναζήτησης ή πατήστε Enter.',
            index :1,
            page:"/MainPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Άνοιγμα επίσκεψης',
            target: 'visitReason',
            content: 'Παρακαλώ εισάγετε τον λόγο επίσκεψής του ασθενή ή επιλέξτε μία από τις επιλογές που δίνονται παρακάτω. Στη συνέχεια, πατήστε "ΑΝΟΙΓΜΑ" για να ξεκινήσετε την επίσκεψη.',
            index :2,
            page:"/PatientPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Εξετάσεις',
            target: 'selectExamsPage',
            content: 'Κάντε κλικ στο κουμπί "ΕΞΕΤΑΣΕΙΣ" για να μεταφερθείτε στην σελίδα των εξετάσεων.',
            index :3,
            page:"/PrescriptionPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Πακέτα εξετάσεων',
            target: 'examsPackageSelect',
            content: `Επιλέξτε "ΠΑΚΕΤΑ ΕΞΕΤΑΣΕΩΝ".`,
            index :4,
            page:"/ReferralPage",
            initialStep:true ,
            finalStep:false
          },
          {
            header: 'Επιλογή Πακέτου εξετάσεων',
            target: 'examsGroupSelect',
            content: `Παρακάτω παρουσιάζονται ομαδοποιημένες οι πιο συχνές εξετάσεις ανάλογα με τη διάγνωση που θέλετε να πραγματοποιήσετε. Κάντε κλικ στη διάγνωση για να δείτε περισσότερες πληροφορίες.`,
            index :5,
            page:"/ReferralPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Επεξεργασία πακέτου εξετάσεων',
            target: 'examePackageExtraInput',
            content: `Μπορείτε να αλλάξετε την διάγνωση, επιλέγοντας μια άλλη σχετική με αυτήν. Μπορείτε επίσης να αλλάξετε τον λόγο παραπομπής και τα σχόλια παραπέμπτικου. Τέλος όπου είναι απαραίτητο, μπορείτε να επιλέξετε μηδενική συμμετοχή για τον ασφαλισμένο.`,
            index :6,
            page:"/ReferralPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Επιλογή εξέτάσεων',
            target: 'packageExamsSelection',
            content: 'Επιλέξτε από τη λίστα εξετάσεων τις εξετάσεις που θέλετε να καταχωρήσετε. Στη συνέχεια, επιλέξτε "ΚΑΤΑΧΩΡΗΣΗ" για να γίνει η εισαγωγή των εξετάσεων με τα αντίστοιχα παραπεμπτικά.',
            index :7,
            page:"/ReferralPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Καταχώρηση παραπεμπτικού',
            target: 'referalPresentationBeforeSend',
            content: `Οι εξετάσεις αυτόματα καταχωρούνται σε παραπεμπτικά με βάση την κατηγορία στην οποία ανήκουν.  Μπορείτε να προσθέσετε όσες εξετάσεις χρειάζεται ο ασθενής και να στείλετε το παραπεμπτικό πατώντας "ΑΠΟΣΤΟΛΗ" (Σύμβολο: "μικρό βέλος που δείχνει προς τα δεξιά)".Κάνοντας κλικ στην εξέταση του παραπεμπτικού, μπορείτε να δείτε αναλυτικές πληροφορίες για την εξέταση. Αν θέλετε να αφαιρέσετε μια εξέταση από το παραπεμπτικό, επιλέξτε το σύμβολο "Χ".`,
            index :8,
            page:"/ReferralPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Διαχείρηση συνταγών',
            target: 'referalPresentationAfterSend',
            content: `Μπορείτε να στείλετε το παραπεμπτικό στον ασθενή (Σύμβολο: μήνυμα), να το εκτυπώσετε (Σύμβολο: εκτυπωτής) ή να το απορρίψετε (Σύμβολο: κάδος). `,
            index :9,
            page:"/ReferralPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Ακύρωση επίσκεψης',
            target: 'cancel',
            content: `Όταν επιλέγετε "ΑΚΥΡΩΣΗ" ακυρώνετε την επίσκεψη καθώς και όλες τις συνταγές και παραπεμπτικά που έχετε εισάγει σε αυτή. Μετά την ακύρωση επιστρέφετε στην αρχική σελίδα. `,
            index :10,
            page:"all",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Ολοκλήρωση επίσκεψης',
            target: 'close',
            content: `Όταν επιλέγετε "ΚΛΕΙΣΙΜΟ", ολοκληρώνετε την επίσκεψη και επιστρέφετε στην αρχική σελίδα. `,
            index :11,
            page:"all",
            initialStep:false,
            finalStep:true
          }
        ]
      }
    },
    {
      index:4,
      description: 'Καταχώρηση Θεραπευτικού Πρωτοκόλλου',
      info:{
        status:true,
        data:[
          {
            header: 'Αναζήτηση ασθενή',
            target: 'amkaSearch',
            content: 'Παρακαλώ εισάγετε το ΑΜΚΑ του ασθενή που θα θέλατε να καταχωρήσετε στην επίσκεψη. Κάντε κλικ στο κουμπί αναζήτησης ή πατήστε Enter.',
            index :1,
            page:"/MainPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Άνοιγμα επίσκεψης',
            target: 'visitReason',
            content: 'Παρακαλώ εισάγετε τον λόγο επίσκεψής του ασθενή ή επιλέξτε μία από τις επιλογές που δίνονται παρακάτω. Στη συνέχεια, πατήστε "ΑΝΟΙΓΜΑ" για να ξεκινήσετε την επίσκεψη.',
            index :2,
            page:"/PatientPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Θεραπευτικά Πρωτόκολλα',
            target: 'TP',
            content: 'Πατήστε το κουμπί "ΟΔΗΓΟΣ Θ.Π." και μετά πατήστε "ΚΑΤΑΧΩΡΗΣΗ Θ.Π." για να μεταβείτε στην σελίδα των Θεραπευτικών πρωτοκόλλων ',
            index :3,
            page:"/PrescriptionPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Έξοδος',
            target: 'exit',
            content: `Για να βγείτε από τη σελίδα των θεραπευτικών πρωτοκόλλων, πατήστε το "Χ" που βρίσκεται στην πάνω δεξιά γωνία.`,
            index :4,
            page:"/ProtocolPage",
            initialStep:true ,
            finalStep:false
          },
          {
            header: 'Επιλογή Πρωτοκόλλου',
            target: 'protocolSelect',
            content: `Επιλέξτε ένα θεραπευτικό πρωτόκολλο από τα υπάρχοντα πατώντας "ΕΠΙΛΟΓΗ" στο αντίστοιχο πρωτόκολλο. Αν θέλετε να προσθέσετε ένα νέο θεραπευτικό πρωτόκολλο, πατήστε "ΠΡΟΣΘΗΚΗ ΝΕΟΥ Θ.Π.". Αν θέλετε να διαγράψετε ένα θεραπευτικό πρωτόκολλο, πατήστε "ΔΙΑΓΡΑΦΗ".`,
            index :5,
            page:"/ProtocolPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Επιλογή διάγνωσης',
            target: 'diagnosisSelect',
            content: `Επιλέξτε τις διαγνώσεις που θέλετε να προσθέσετε στο Θεραπευτικό Πρωτόκολλο. Εάν μια διάγνωση που θέλετε ήδη υπάρχει στο πρωτόκολλο, επιλέξτε "ΣΥΝΕΧΕΙΑ". Αν δεν υπάρχει, επιλέξτε "ΠΡΟΣΘΗΚΗ ΝΕΑΣ ΔΙΑΓΝΩΣΗΣ" και διαλέξτε τη διάγνωση που θέλετε να προσθέσετε.`,
            index :6,
            page:"/ProtocolPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Επιλογή βήματος',
            target: 'stepSelect',
            content: `Μπορείτε να επαναλάβετε ένα υπάρχον βήμα θεραπευτικού πρωτοκόλου επιλέγοντας "ΕΠΑΝΑΛΗΨΗ" ή μπορείτε να δημιουργήσετε ένα νέο βήμα επιλέγοντας "ΝΕΟ ΒΗΜΑ". Αν κάνετε κλικ πάνω στο βήμα του ασθενούς, θα δείτε όλες τις πληροφορίες του βήματος, καθώς και τις δραστικές ουσίες που ξεκλειδώνει.Σε περίπτωση επανάληψης θα ξεκλειδωθούν οι δραστικές ουσίες του βήματος και θα μεταφερθειτε συην σελίδα της συνταγογράφησης.`,
            index :7,
            page:"/ProtocolPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Καθορισμός παραμέτρων',
            target: 'parametersSelection',
            content: 'Παρακαλώ προσδιορίστε τις απαραίτητες παραμέτρους για κάθε περίπτωση και επιλέξτε "ΣΥΝΕΧΕΙΑ"',
            index :8,
            page:"/ProtocolPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Επικαιροποίηση παραμέτρων',
            target: 'parametersConfirmation',
            content: `Ελέγξτε τις παραμέτρους και επιλέξτε "ΣΥΝΕΧΕΙΑ.`,
            index :9,
            page:"/ProtocolPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Επιλογή νέου βήματος',
            target: 'stepSelect',
            content: `Παρακαλώ επιλέξτε ένα βήμα για να προστεθεί στο θεραπευτικό πρωτόκολλο. Κάντε κλικ στο "ΣΥΝΕΧΕΙΑ" για να προχωρήσετε.`,
            index :10,
            page:"/ProtocolPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Επιλογή δραστικών ουσιών',
            target: 'activeSubsSelect',
            content: `Παρακαλώ επιλέξτε τις δραστικές ουσίες σύμφωνα με το θεραπευτικό πρωτόκολλο. Επιλέξτε την ομάδα των δραστικών ουσιών που επιθυμείτε να εισάγετε, επιλέξτε τις δραστικές ουσίες, και στη συνέχεια πατήστε "ΣΥΝΕΧΕΙΑ" για να προχωρήσετε.`,
            index :11,
            page:"/ProtocolPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Ολοκλήρωση',
            target: 'registerProtocol',
            content: `Επιλέξτε "Καταχώρηση Θ.Π." για να εισάγετε το θεραπευτικό πρωτόκολλο στην επίσκεψη. Μετά την επιτυχή καταχώρηση, θα μεταφερθείτε στη σελίδα συνταγογράφησης.`,
            index :12,
            page:"/ProtocolPage",
            initialStep:false,
            finalStep:true
          }
        ]
      }
    },
    {
      index:5,
      description: 'Δημιουργια παραπομπής',
      info:{
        status:true,
        data:[
          {
            header: 'Αναζήτηση ασθενή',
            target: 'amkaSearch',
            content: 'Παρακαλώ εισάγετε το ΑΜΚΑ του ασθενή που θα θέλατε να καταχωρήσετε στην επίσκεψη. Κάντε κλικ στο κουμπί αναζήτησης ή πατήστε Enter.',
            index :1,
            page:"/MainPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Άνοιγμα επίσκεψης',
            target: 'visitReason',
            content: 'Παρακαλώ εισάγετε τον λόγο επίσκεψής του ασθενή ή επιλέξτε μία από τις επιλογές που δίνονται παρακάτω. Στη συνέχεια, πατήστε "ΑΝΟΙΓΜΑ" για να ξεκινήσετε την επίσκεψη.',
            index :2,
            page:"/PatientPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Παραπομπές',
            target: 'referencesSelect',
            content: 'Κάντε κλικ στο κουμπί "ΠΑΡΑΠΟΜΠΕΣ" για να μεταφερθείτε στην σελίδα των παραπομπών.',
            index :3,
            page:"/PrescriptionPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Δημιουργία παραπομπής',
            target: 'createReference',
            content: `Παρακαλώ επιλέξτε το κουμπί που βρίσκεται στην πάνω δεξιά πλευρά για να δημιουργήσετε μια παραπομπή.`,
            index :4,
            page:"/ReferencePage",
            initialStep:true ,
            finalStep:false
          },
          {
            header: 'Αιτιολογία παραπομπής',
            target: 'createRefenceForm',
            content: `Εισάγετε τον "ΤΥΠΟ ΠΑΡΑΠΟΜΠΗΣ", την "ΕΙΔΙΚΟΤΗΤΑ" του ιατρού που θα στείλετε την παραπομπή, καθώς επίσης και την "ΔΙΑΓΝΩΣΗ" της παραπομπής`,
            index :5,
            page:"/ReferencePage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Συνοδά νοσήματα',
            target: 'createRefenceFormAdditional',
            content: `Εκτός από τις βασικές πληροφορίες σχετικά με την παραπομπή, μπορείτε να προσθέσετε και συνοδά νοσήματα συμπληρώνοντας τη "διάγνωση" και το ICPC-2.`,
            index :6,
            page:"/ReferencePage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Καταχώρηση παραπομπής',
            target: 'referenceSend',
            content: `Παρακαλώ επιλέξτε "καταχώρηση" μετά τη συμπλήρωση της παραπομπής.`,
            index :7,
            page:"/ReferencePage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Πληροφορίες παραπομπής',
            target: 'referencePresent',
            content: `Μπορείτε να εκτυπώσετε την παραπομπή και να τη διαγράψετε;`,
            index :8,
            page:"/ReferencePage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Ολοκλήρωση επίσκεψης',
            target: 'close',
            content: `Επιλέξτε "ΚΛΕΙΣΙΜΟ",για να ολοκληρώσετε την επίσκεψη και να επιστρέψετε στην αρχική σελίδα. `,
            index :9,
            page:"all",
            initialStep:false,
            finalStep:true
          }
  
          
        ]
      }
    },
    {
      index:6,
      description: 'Ολοκλήρωση παραπομπής',
      info:{
        status:true,
        data:[
          {
            header: 'Αναζήτηση ασθενή',
            target: 'amkaSearch',
            content: 'Παρακαλώ εισάγετε το ΑΜΚΑ του ασθενή που θα θέλατε να καταχωρήσετε στην επίσκεψη. Κάντε κλικ στο κουμπί αναζήτησης ή πατήστε Enter.',
            index :1,
            page:"/MainPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Άνοιγμα επίσκεψης',
            target: 'visitReason',
            content: 'Παρακαλώ εισάγετε τον λόγο επίσκεψής του ασθενή ή επιλέξτε μία από τις επιλογές που δίνονται παρακάτω. Στη συνέχεια, πατήστε "ΑΝΟΙΓΜΑ" για να ξεκινήσετε την επίσκεψη.',
            index :2,
            page:"/PatientPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Παραπομπές',
            target: 'referencesSelect',
            content: 'Κάντε κλικ στο κουμπί "ΠΑΡΑΠΟΜΠΕΣ" για να μεταφερθείτε στην σελίδα των παραπομπών.',
            index :3,
            page:"/PrescriptionPage",
            initialStep:true,
            finalStep:true
          },
          {
            header: 'Επιλογή παραπομπής',
            target: 'selectReference',
            content: `Παρακαλώ επιλέξτε ΟΛΟΚΛΗΡΩΣΗ για να διαλέξετε την παραπομπή που θέλετε να ολοκληρώσετε.`,
            index :4,
            page:"/ReferencePage",
            initialStep:true ,
            finalStep:false
          },
          {
            header: 'Ολοκλήρωση παραπομπής',
            target: 'completeRefenceForm',
            content: `Παρακαλώ εισάγετε την "ΔΙΑΓΝΩΣΗ" ή "ICPC-2" και κάντε κλικ στο "ολοκλήρωση" για να ολοκληρώσετε την παραπομπή.`,
            index :5,
            page:"/ReferencePage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Πληροφορίες παραπομπής',
            target: 'referenceCompletePresent',
            content: `Μπορείτε να εκτυπώσετε την ολοκληρωμένη παραπομπή ή να την ακυρώσετε;`,
            index :6,
            page:"/ReferencePage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Ολοκλήρωση επίσκεψης',
            target: 'close',
            content: `Επιλέξτε "ΚΛΕΙΣΙΜΟ",για να ολοκληρώσετε την επίσκεψη και να επιστρέψετε στην αρχική σελίδα. `,
            index :7,
            page:"all",
            initialStep:false,
            finalStep:true
          }
        ]
      }
    },
    {
      index:7,
      description: 'Επισκόπηση κεντρικής σελίδας',
      info:{
        status:true,
        data:[
          {
            header: 'Κεντρική σελίδα',
            target: '',
            content: `Στην κεντρική σελίδα μπορείτε να αναζητήσετε έναν ασθενή για την έναρξη της επίσκεψης και να καταχωρήσετε τις ημερήσιες επισκέψεις σας στο Ε-ΔΑΠΥ. Επιπλέον, παρουσιάζονται οι ολοκληρωμένες επισκέψεις σας καθώς και πληροφορίες σχετικά με τη συνταγογράφηση, όπως το μηνιαίο φαρμακευτικό κόστος, κόστος ανά ασθενή, όρια συνταγογράφησης και άλλες πληροφορίες.`,
            index :1,
            page:"/MainPage",
            initialStep:true,
            finalStep:false
          },
          {
            header: 'Αναζήτηση ασθενή',
            target: 'amkaSearch',
            content: 'Αναζήτηση ασθενή για την έναρξη της επίσκεψης',
            index :2,
            page:"/MainPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Πληροφορίες',
            target: 'information',
            content: `Επιλέγοντας το κουμπί "Πληροφορίες" (πάνω δεξιά) παρουσιάζονται πληροφορίες σχετικά με:\n
            1. "Τα στοιχεία μου": Ονοματεπώνυμο, ειδικότητα, ΑΜΚΑ, κτλ....
            2. "Μονάδα Συνταγογράφησης": Περιλαμβάνει λεπτομέρειες σχετικά με τη συνταγογράφηση σε ανασφάλιστους, σε ασφαλισμένους πρόνοιας, συνταγογράφηση φαρμάκων, κτλ....
            3. "Κόστος Συνταγογράφησης": Παρουσιάζει πληροφορίες σχετικά με την συνολική μηνιαία φαρμακευτική δαπάνη, Μέσο κόστος ανά ασθενή, Ανώτατο επιτρεπτό κόστος συνταγογράφησης ανά ασθενή, ... .
            4. "DHPC": Αυτά αναφέρονται σε επίσημες ανακοινώσεις, κανονισμούς ή οδηγίες που αφορούν τον τομέα της υγείας και της φαρμακευτικής περίθαλψης.
            5. "Επισκέψεις ΕΟΠΥΥ": Πληροφορίες σχετικά με την σύμβαση σας με τον ΕΟΠΥΥ
            6. "Βοήθεια": Οδηγός που παρέχεται για την εκπαίδευση ή την εξοικείωση των χρηστών με το σύστημα συνταγογράφησης. Αυτός ο οδηγός περιέχει οδηγίες, πληροφορίες και βήματα για την αποτελεσματική χρήση του συστήματος.`,
            index :3,
            page:"/MainPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Επισκέψεις',
            target: 'visitsBox',
            content: `Παρουσιάζονται οι ολοκληρωμένες επισκέψεις που πραγματοποιήσατε.`,
            index :4,
            page:"/MainPage",
            initialStep:false ,
            finalStep:false
          },
          {
          header: 'Επισκέψεις ημέρας',
          target: 'visitsToday',
          content: `Επιλέγοντας το κουμπί "Επισκέψεις ημέρας", παρουσιάζονται οι επισκέψεις που πραγματοποιήσατε σήμερα.`,
          index :5,
          page:"/MainPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Επισκέψεις μήνα',
          target: 'visitsMonth',
          content: `Επιλέγοντας το κουμπί "Επισκέψεις μήνα", παρουσιάζονται οι επισκέψεις που πραγματοποιήσατε τον τρέχων μήνα.`,
          index :6,
          page:"/MainPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Επισκέψεις ασθενή',
          target: 'visitsPatient',
          content: `Επιλέγοντας το κουμπί "Αναζήτηση επισκέψεων μέσω ΑΜΚΑ", παρουσιάζονται όλες οι επισκέψεις που πραγματοποίησε ο ασθενής που αναζητάτε σε εσάς.`,
          index :7,
          page:"/MainPage",
          initialStep:false ,
          finalStep:false
          },  
          {
          header: 'Πληροφορίες Επισκέψης',
          target: 'visitInformation',
          content: `Κατά την κάθε επίσκεψη, παρέχονται όλες οι πληροφορίες σχετικά με τις συνταγές και τα παραπεμπτικά που καταχωρήθηκαν σε αυτήν.\nΜπορείτε να κλείσετε το παράθυρο με τις πληροφορίες της επίσκεψη επιλέγοντας το σύμβολο "Χ".`,
          index :8,
          page:"/MainPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Επισκέψεις ασθενή',
          target: 'visitActions',
          content: `Μπορείτε να ακυρώσετε την επίσκεψη, να την εκτυπώσετε ή να αλλάξετε την χρέωση της στο όριο επισκέψεων.`,
          index :9,
          page:"/MainPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Συνταγές και παραπεμπτικά επίσκεψης',
          target: 'visitsFullInfo',
          content: `Όταν κάνετε κλικ πάνω στην επίσκεψη, εμφανίζονται οι συνταγές και τα παραπεμπτικά που καταχωρήθηκαν σε αυτήν.`,
          index :10,
          page:"/MainPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Συνταγές επίσκεψης',
          target: 'visitPrescriptions',
          content: `Επιλέγοντας τη συνταγή μπορείτε να δείτε όλα τα καταχωρημένα φαρμακευτικά σκευάσματα με το αντίστοιχο δοσολογικό σχήμα και τη διάγνωση που χρησιμοποιήθηκε.\n Μπορείτε να ακυρώσετε μια συνταγή επιλέγοντας "Ακύρωση"  {σύμβολο του κάδου}, να την εκτυπώσετε ξανά επιλέγοντας "Εκτύπωση" (σύμβολο του εκτυπωτή)  να την αποστείλετε ηλεκτρονικά στον ασθενή επιλέγοντας "Αποστολή συνταγής"  (σύμβολο του βέλους προς τα δεξιά).`,
          index :11,
          page:"/MainPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Παραπεμπτικά επίσκεψης',
          target: 'visitsReferals',
          content: `Το ίδιο ισχύει και για τα παραπεμπτικά. Όπως και στις συνταγές μπορείτε να τα δείτε όλες τις καταχωρημένες εξετάσεις, να τα ακυρώσετε, να τα εκτυπώσετε ή να τα αποστείλετε ξανά στον ασθενή.`,
          index :12,
          page:"/MainPage",
          initialStep:false ,
          finalStep:true
          },
        ]
      }
    },
    {
      index:8,
      description: 'Επισκόπηση σελίδας ασθενή',
      info:{
        status:true,
        data:[
          {
            header: 'Αναζήτηση ασθενή',
            target: 'amkaSearch',
            content: 'Παρακαλώ εισάγετε το ΑΜΚΑ του ασθενή που θα θέλατε να καταχωρήσετε στην επίσκεψη. Κάντε κλικ στο κουμπί αναζήτησης ή πατήστε Enter.',
            index :1,
            page:"/MainPage",
            initialStep:true,
            finalStep:true
          },
          {
          header: 'Ιατρικός Φάκελος Ασθενούς',
          target: '',
          content: `Στη σελίδα "Ιατρικός Φάκελος Ασθενούς" παρουσιάζονται τα βασικά στοιχεία για τον ασθενή καθώς και μια σύντομη αναφορά στο ιστορικό του. 
          Επιπλεόν μπορούμε να ανοιξουμε την επισκεψη για να καταχωρήσουμε συνταγες και παραπεμπτικα`,
          index :2,
          page:"/PatientPage",
          initialStep:true,
          finalStep:false
          },
          {
          header: 'Πληροφορίες ασφαλισμένου',
          target: 'patientMainInfo',
          content: 'Οι "Πληροφορίες ασφαλισμένου" περιέχουν τα βασικά στοιχεία για τον ασφαλισμένο, τα στοιχεία επικοινωνίας και τις πληροφορίες συνταγογράφησης.',
          index :3,
          page:"/PatientPage",
          initialStep:false,
          finalStep:false
          },
          {
          header: 'Ιστορικό συνταγογράφησης',
          target: 'patientPrescriptionHistory',
          content: `Επιλέγοντας το "Ιστορικό συνταγογράφησης" παρουσιάζονται όλες οι επισκέψεις του ασθενούς σε εσάς, αποκλειστικά και μόνο εσάς, καθώς και τα αντίστοιχα φάρμακα και εξετάσεις που του έχουν δοθεί.`,
          index :4,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Πληροφορίες ημέρας',
          target: 'dayPresentation',
          content: `Πατώντας πάνω στην ημερομηνία, εμφανίζονται τα φάρμακα και οι εξετάσεις που έχουν καταχωρηθεί την ημέρα αυτή στον ασθενή.`,
          index :5,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Πληροφορίες φαρμάκου/εξέτασης',
          target: 'dayPrescriptionReferalPresentation',
          content: `Πατώντας πάνω σε ένα φάρμακο ή μια εξέταση, εμφανίζονται πληροφορίες όπως το δοσολογίκό σχήμα της αγωγής, καθώς και πληροφορίες σχετικά με τη διάγνωση.

          Για να κλείσετε το παράθυρο, κάντε κλικ στο "Χ".`,
          index :6,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Ιστορικό ασθενή',
          target: 'patientMedicalHistory',
          content: `Επιλέγοντας το "Ιατρικό ιστορικό" παρουσιάζεται το σύντομο ιατρικό ιστορικό του ασθενή.
          
          Προυπόθεση για να έχετε πρόσβαση στο ιστορικό του ασθενή είναι ο ασθενής να είναι καταχωρημένος στην ομάδα ασθενών "Οι ασθενείς μου".`,
          index :7,
          page:"/PatientPage",
          initialStep:false,
          finalStep:false
          },
          {
          header: 'Δημογραφικά',
          target: 'demographics',
          content: `Πατώντας πάνω στα "Δημογραφικά" εμφανίζονται οι βασικές πληροφορίες του ασθενή.`,
          index :8,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Πλήρες ιστορικό συνταγογραφήσεων',
          target: 'prescriptionHistoryFull',
          content: `Το "Πλήρες ιστορικό συνταγογραφήσεων" περιλαμβάνει όλες τις επισκέψεις του ασθενούς σε κάθε ιατρό. 
          
          Κάνοντας κλικ πάνω στην ημερομηνία, εμφανίζονται οι εξετάσεις και τα φάρμακα που καταχωρήθηκαν στον ασθενή.`,
          index :9,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Χρησιμοποιημένα φαρμακευτικά σκευάσματα',
          target: 'distinctMedicines',
          content: `Επιλέγοντας το "Χρησιμοποιημένα φαρμακευτικά σκευάσματα", παρουσιάζονται τα φάρμακα που έχει λαβεί ο ασθενής και η ασθένεια για την οποία τα χρησιμοποίηθηκαν.`,
          index :10,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Εργαστηριακοί και απεικονιστικοί έλεγχοι',
          target: 'distinctTests',
          content: `Επιλέγοντας το "Εργαστηριακοί και απεικονιστικοί έλεγχοι", παρουσιάζονται οι πιο συχνοί εργαστηριακοί και απεικονιστικοί έλεγχοι που έχει υποβληθεί ο ασθενής καθώς και η αντίστοιχη ασθένεια.`,
          index :11,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Ιστορικό κύριων ενοχλημάτων',
          target: 'documentedVisits',
          content: `Επιλέγοντας το "Ιστορικό Κύριων Ενοχλημάτων", βλέπετε το ιατρικό ιστορικό που πήρατε από τον ασθενή, οργανωμένο ανά ημέρες.`,
          index :12,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Ιστορικό ημέρας',
          target: 'documentedVisitsDay',
          content: `Κατά την επιλογή μιας ημερομηνίας από το ιατρικό ιστορικό του ασθενή, παρουσιάζονται οι πληροφορίες που αφορούν το ιστορικό του προβλήματος (συμπτωμάτα, κλινικά σημεία, επισκόπηση των συστημάτων, κτλ...).
          
          Για να κλείσετε το παράθυρο, κάντε κλικ στο "ΕΠΙΣΤΡΟΦΗ".`,
          index :13,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Βιομετρικά στοιχεία',
          target: 'biometrics',
          content: `Επιλέγοντας το "Βασικοί δείκτες υγείας", παρουσιάζονται πληροφορίες οπως βάρος, ύψος, πίεση, κτλ... .`,
          index :14,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Διαγνώσεις',
          target: 'diagnoses',
          content: `Επιλέγοντας το "Διαγνώσεις," θα δείτε τις πιο συχνές ασθένειες του ασθενή και τα ποσοστά εμφάνισής τους. 
          
          Επιπλέον, μπορείτε να προσθέσετε και άλλες διαγνώσεις επιλέγοντας "ΠΡΟΣΘΗΚΗ ΔΙΑΓΝΩΣΗΣ".`,
          index :15,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Αλλεργίες / Αντενδείξεις',
          target: 'patientAllergies',
          content: `Όταν επιλέγετε την κατηγορία "Αλλεργίες / Αντενδείξεις," εμφανίζονται οι αλλεργίες του ασθενή. 
          
          Επιπλέον, εάν επιλέξετε κάποια αλλεργία, παρουσιάζονται πληροφορίες σχετικά με την αλλεργία.`,
          index :16,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Νοσηλείες',
          target: 'hospitalizations',
          content: `Όταν επιλέγετε την κατηγορία "Νοσηλείες" εμφανίζονται οι νοσηλείες του ασθενούς. 
          
          Αν θέλετε να προσθέσετε μια νέα νοσηλεία, απλά επιλέξτε "ΠΡΟΣΘΗΚΗ".`,
          index :17,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Εμβολιασμοί',
          target: 'vaccinations',
          content: `Επιλέγοντας την κατηγορία "Εμβολιασμοί", παρουσιάζονται οι εμβολιασμοί του ασθενή.`,
          index :18,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Οικογενειακό ιστορικό',
          target: 'familyHistory',
          content: `Επιλέγοντας την κατηγορία "Οικογενειακό ιστορικό", παρουσιάζονται βασικές πληροφορίες για τις χρόνιες ασθένειες που πιθανόν να έχουν τα συγγενικά πρόσωπα του ασθενή.`,
          index :19,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
          header: 'Κοινωνικό ιστορικό',
          target: 'socialHistory',
          content: `Επιλέγοντας την κατηγορία "Κοινωνικό ιστορικό", παρουσιάζονται βασικές πληροφορίες σχετικά με τις κοινωνικές συνήθειες του ασθενούς. .`,
          index :20,
          page:"/PatientPage",
          initialStep:false ,
          finalStep:false
          },
          {
            header: 'Ενημέρωση Ιστορικού',
            target: 'takeHistory',
            content: `Επιλέγοντας τη λειτουργία "Ενημέρωση Ιστορικού", μπορείτε να καταγράψετε το ιστορικό του ασθενή (κύριο σύμπτωμα, κλινικά σημεία και  επισκίοπηση συστημάτων) .`,
            index :21,
            page:"/PatientPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Συμπτώμα/Κλινικά σημεία',
            target: 'symptom',
            content: `Περιγράψτε τον λόγο επίσκεψης και τα κλινικά σημεία του ασθενή συμπληρώνοντας την φόρμα "Κύριο σύμπτωμα`,
            index :22,
            page:"/PatientPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Επισκόπηση συστημάτων',
            target: 'ros',
            content: `Επιλέξτε τα κλινικά σημεία για κάθε σύστημα. 
            
            Πατήστε "ΚΑΤΑΧΩΡΗΣΗ" για να καταγραφεί το ιστορικό στα στοιχεία του ασθενή.`,
            index :23,
            page:"/PatientPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Λόγος επίσκεψης',
            target: 'visitReasonText',
            content: `Σε περίπτωση καταχώρησης φαρμάκων ή εξετάσεων, γράψτε τον λόγο της επίσκεψής του ασθενή.`,
            index :24,
            page:"/PatientPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Σχόλιο επίσκεψης',
            target: 'visitComment',
            content: ``,
            index :25,
            page:"/PatientPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Άνοιγμα',
            target: 'openVisit',
            content: `Ανοίγει την επίσκεψη`,
            index :26,
            page:"/PatientPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Επιστροφή',
            target: 'returnMainPage',
            content: `Όταν πατάτε το κουμπί "Επιστροφή", επιστρέφετε στην αρχική σελίδα.`,
            index :27,
            page:"/PatientPage",
            initialStep:false ,
            finalStep:true
          },
          
        ]
      }
    },
    {
      index:9,
      description: 'Καταχώρηση επισκέψεων στο Ε-ΔΑΠΥ',
      info:{
        status:true,
        data:[
          {
            header: 'Ε-ΔΑΠΥ',
            target: 'edapy',
            content: `Σε περίπτωση που έχετε συμβάση με τον ΕΟΠΥΥ, πατήστε το κουμπί "ΕΔΑΠΥ" στο κάτω τμήμα της σελίδας για να καταχωρήσετε τις επισκέψεις σας στον ΕΟΠΥΥ.`,
            index :1,
            page:"/MainPage",
            initialStep:true,
            finalStep:false
          },
          {
            header: 'Επισκέψεις',
            target: 'edapyVisits',
            content: `Οι επισκέψεις που έχουν την κατάσταση "προς αποστολή" στο eΔΑΠΥ είναι αυτές που θα σταλούν στον ΕΟΠΥΥ.`,
            index :2,
            page:"/MainPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Επεξεργασία επίσκεψης',
            target: 'editEdapyVisit',
            content: `Μπορείτε να κλικάρετε στην επίσκεψη και να επεξεργαστείτε στοιχεία της, όπως αν είναι επείγουσα, το τηλέφωνο του ασθενούς, αν θα υποβληθεί η επίσκεψη στον ΕΟΠΥΥ και αν ο ασθενής ήταν παρών κατά τη διάρκεια της επίσκεψης. 

            Για να σταλεί η επίσκεψη στον ΕΟΠΥΥ επιλέξτε ως κατασταση επίσκεψης "Προς αποστολή".
            
            Αφού επεξεργαστείτε την επίσκεψη, μπορείτε να επιλέξετε "Ενημέρωση" για να αποθηκεύσετε τις αλλαγές ή "Επιστροφή" για να επιστρέψετε στις επισκέψεις χωρίς αποθήκευση των αλλαγών.`,
            index :3,
            page:"/MainPage",
            initialStep:false,
            finalStep:false
          },
          {
            header: 'Καταχώρηση',
            target: 'sendDapyVisit',
            content: `Όταν έχετε επιλέξει όλες τις επισκέψεις προς αποστολή, κάνετε κλικ στο "Αποστολή ΕΔΑΠΥ". 
            
            Στη συνέχεια, μετά την εισαγωγή των κωδικών ΕΔΑΠΥ, οι επισκέψεις θα καταχωρηθούν στο σύστημα του ΕΟΠΥΥ.`,
            index :4,
            page:"/MainPage",
            initialStep:false ,
            finalStep:false
          },
          {
            header: 'Έξοδος',
            target: 'exitEdapy',
            content: `Για να βγείτε από τη διαδικασία καταχώρησης επισκέψεων στον ΕΔΑΠΥ, πατήστε το πλήκτρο "Χ" που βρίσκεται στην πάνω δεξιά γωνία της σελίδας.`,
            index :5,
            page:"/MainPage",
            initialStep:false ,
            finalStep:true
          }
        ]
      }
    }
  
  
  ]

  return(  
    <Dialog fullWidth maxWidth="md" scroll='paper'  aria-labelledby="Βοήθεια" open={openHelpDialog}>
  
      <DialogTitle >
        Βοήθεια και Οδηγίες
      </DialogTitle>

      <DialogContent dividers>
        <DialogContentText id="Βοήθεια">
          Εδώ θα βρείτε οδηγίες και συμβουλές για να αξιοποιήσετε πλήρως την εφαρμογή. Παρακάτω παραθέτουμε τις βασικές χρήσεις της εφαρμογής. Επιλέγοντας μια από τις παρακάτω ενότητες, θα ενεργοποιηθεί η αντίστοιχη βοήθεια που θα σας καθοδηγήσει σε όλη τη διαδικασία.
        </DialogContentText>

        <List dense>
          {help.map((x, index)=>
            <ListItem button onClick={()=> {setSteps(x.info); setOpenHelpDialog(false)}} key={index}>
              <ListItemIcon>
                <Avatar>{x.index}</Avatar>
              </ListItemIcon>
              <ListItemText style={{overflowWrap: 'break-word'}} primary={x.description}  />
            </ListItem>
          )}
        </List>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'left' }}>
        <Tooltip title = "Επιλέγοντας αυτό το πλαίσιο, θα εμφανίζεται αυτό το παράθυρο κάθε φορά που ξεκινάς την εφαρμογή." arrow={true} placement="bottom">
          <FormControlLabel
          control={<Checkbox checked={!autoShow} onChange={disableAutoShow} color="default" />}
          label={<Typography color="textSecondary" variant="subtitle2">Βοήθεια και Οδηγίες.</Typography>}
          />      
        </Tooltip> 
    
        <Tooltip title = "Ενεργοποιώντας αυτό το πλαίσιο, θα εμφανίζονται μικρές εξηγήσεις για το τι κάνει κάθε κουμπί και κάθε ενέργεια στην εφαρμογή." arrow={true} placement="bottom">
        <FormControlLabel
        control={<Checkbox checked={!autoShowTooltips} onChange={disableAutoShowTooltips} color="default" />}
        label={<Typography color="textSecondary" variant="subtitle2">Μηνύματα βοήθειας.</Typography>}
        />
        </Tooltip> 
      
      </DialogActions>
      <Divider/>
      <DialogActions style={{ float: 'right'}}>
        <Button variant='outlined' color='secondary' onClick={closeHelpDialog}>ΚΛΕΙΣΙΜΟ</Button>
      </DialogActions>
    </Dialog>
  )
}



  return(
    <>


        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography  variant='h6' color="inherit">Πληροφορίες</Typography>
          <Typography variant='subtitle2' color="inherit"> Επιλέγοντας το κουμπί "Πληροφορίες", θα εμφανιστούν στοιχεία και οδηγίες που αφορούν τη χρήση της εφαρμογής.</Typography>
        </React.Fragment>
        :'' } 
        >
        <IconButton className ="information" onClick={handleClick} aria-label="user" >
          <Info style={{color:"white", fontSize: '60'}}/>
        </IconButton>
      </Tooltip>
 
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >

        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography variant='subtitle2' color="inherit"> Επιλέγοντας "Η συνδρομή μου", θα βρείτε πληροφορίες σχετικά με την τρέχουσα συνδρομή σας.</Typography>
        </React.Fragment>
        :'' } 
        >
          <MenuItem button onClick={handleDemo} key="0">
            <ListItemIcon>
              <AccountBox/>
            </ListItemIcon>
            <ListItemText primary="Η συνδρομή μου" />
          </MenuItem>
        </Tooltip>


        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography variant='subtitle2' color="inherit"> Επιλέγοντας "Τα στοιχεία μου", θα βρείτε πληροφορίες σχετικά με εσάς, τον χρήστη της εφαρμογής.</Typography>
        </React.Fragment>
        :'' } 
        >
          <MenuItem button onClick={handleDemo} key="1">
            <ListItemIcon>
              <Person/>
            </ListItemIcon>
            <ListItemText primary="Τα στοιχεια μου" />
          </MenuItem>
        </Tooltip>
        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography variant='subtitle2' color="inherit"> Επιλέγοντας το 'Μονάδα Συνταγογράφησης', θα βρείτε πληροφορίες σχετικά με τις δυνατότητες και περιορισμούς συνταγογράφησης που προσφέρει μόναδα που επιλέξατε.</Typography>
        </React.Fragment>
        :'' } 
        >
        <MenuItem button onClick={handleDemo} key="2">
          <ListItemIcon>
            <LocalHospital/>
          </ListItemIcon>
          <ListItemText primary="Μονάδα συνταγογράφησης" />
        </MenuItem>
        </Tooltip>
        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography variant='subtitle2' color="inherit"> Κάνοντας κλικ στο "Κόστος συνταγογραφησης", θα δείτε πληροφορίες για το κόστος της συνταγογραφησής σας.</Typography>
        </React.Fragment>
        :'' } 
        >
        <MenuItem button onClick={handleDemo} key="3">
          <ListItemIcon>
            <Euro/>
          </ListItemIcon>
          <ListItemText primary="Κοστος συνταγογραφησης" />
        </MenuItem>
        </Tooltip>
        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography variant='subtitle2' color="inherit">Επιλέγοντας "Επισκέψεις ΕΟΠΥΥ", θα βρείτε πληροφορίες σχετικά με τις καταχωρημένες επισκέψεις σας στον ΕΟΠΥΥ.</Typography>
        </React.Fragment>
        :'' } 
        >
        <MenuItem button onClick={handleDemo}key="4">
          <ListItemIcon>
            <PeopleAlt/>
          </ListItemIcon>
          <ListItemText primary="Επισκέψεις ΕΟΠΥΥ" />
        </MenuItem>
        </Tooltip>
        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography variant='subtitle2' color="inherit">Με την επιλογή "DHPC", μπορείτε να δείτε όλα τα μηνύματα DHPC που έχετε λάβει.</Typography>
        </React.Fragment>
        :'' } 
        >
        <MenuItem button onClick={handleDemo} key="5">
          <ListItemIcon>
            <Message/>
          </ListItemIcon>
          <ListItemText primary="DHPC" />
        </MenuItem>
        </Tooltip>       
        
        <Divider />

        
        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography variant='subtitle2' color="inherit">Αν οι επισκέψεις σας δεν είναι ενημερωμένες, μπορείτε να πατήσετε στο κουμπί "Ενημέρωση επισκέψεων" για να τις ενημερώσετε.</Typography>
        </React.Fragment>
        :'' } 
        >
        <MenuItem button onClick={handleDemo} key="6">
          <ListItemIcon>
            <Refresh/>
          </ListItemIcon>
          <ListItemText primary= "Ενημέρωση επισκέψεων" />
        </MenuItem>
        </Tooltip>
        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography variant='subtitle2' color="inherit"> Για να μάθετε πώς να χρησιμοποιείτε την εφαρμογή, πατήστε το κουμπί Βοήθεια. Θα σας δώσει οδηγίες για τις βασικές λειτουργίες.</Typography>
        </React.Fragment>
        :'' } 
        >
        <MenuItem button onClick={helpDialogOpen} key="7">
          <ListItemIcon>
            <HelpOutline/>
          </ListItemIcon>
          <ListItemText primary="Βοήθεια" />
        </MenuItem>
        </Tooltip>

        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography variant='subtitle2' color="inherit"> Μπορείτε να ενημερωθείτε για τις ανακοινώσεις της ΗΔΙΚΑ πατώντας το αντίστοιχο κουμπί  .</Typography>
        </React.Fragment>
        :'' } 
        >
        <MenuItem button onClick={handleDemo} key="8">
          <ListItemIcon>
            <Info/>
          </ListItemIcon>
          <ListItemText primary="Ανακοινώσεις ΗΔΙΚΑ" />
        </MenuItem>
        </Tooltip>
       
        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography variant='subtitle2' color="inherit"> Μπορείτε να εκτελέσετε όλες τις απαραίτητες ενέργειες διαχείρισης δεδομένων πατώντας το αντίστοιχο κουμπί  .</Typography>
        </React.Fragment>
        :'' } 
        >
        <MenuItem button onClick={handleDemo} key="9">
          <ListItemIcon>
            <Storage/>
          </ListItemIcon>
          <ListItemText primary="Δεδομένα" />
        </MenuItem>
        </Tooltip>

        <Tooltip
        title={!helpActivatedTooltips ?
        <React.Fragment>
          <Typography variant='subtitle2' color="inherit"> Μπορείτε να εκπαιδεύσετε την εφαρμογή πατώντας το αντίστοιχο κουμπί.</Typography>
        </React.Fragment>
        :'' } 
        >
        <MenuItem button onClick={handleDemo} key="10">
          <ListItemIcon>
            <EmojiObjects/>
          </ListItemIcon>
          <ListItemText primary="Εκπαίδευση εφαρμογής" />
        </MenuItem>
        </Tooltip>

        
        
      </Menu>
      
<Help/>

      

    </>
  )
}
export const MainPage = () => {

  //Check if the user is logged
  const [logged, setLogged] = useContext(LoggedContext)
  //Transition for the main page
  const [grow, setGrow] = useState(true)
  //HelpActivatedContext data the tooltips show condition

  const setDemoMessage = useDemoStore(state => state.setDemoMessage)
  const setDemoDialog = useDemoStore(state => state.setDemoDialog)
  const newVisit = useStore(state => state.newVisit);

  //If the patient has multiple insurances open the "SelectIncurance" dialog
  useEffect(() => {

    if(!newVisit){
      setDemoDialog({
        status:true,
        description:<>
   
        <Typography variant="body1" gutterBottom>
                    <strong>Καλώς ήρθατε στην κεντρική σελίδα της εφαρμογής!</strong>
                </Typography>
        <br></br>
        <Typography variant="subtitle2" gutterBottom>
          Βασικές λειτουργίες.
        </Typography>
        
        <List dense>
          <ListItem>
            <ListItemText 
              primary={
                <Typography variant="subtitle2">
                  <span style={{ fontWeight: 'bold' }}>Επισκέψεις:</span> Δείτε μια συνοπτική εικόνα των ολοκληρωμένων επισκέψεων της ημέρας και του μήνα.
                </Typography>
              }
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary={
                <Typography variant="subtitle2">
                  <span style={{ fontWeight: 'bold' }}>Νέες επισκέψεις:</span> Για να δημιουργήσετε μια νέα επίσκεψη, αναζητήστε τον ασθενή χρησιμοποιώντας το ΑΜΚΑ του, στο πεδίο αναζήτησης που βρίσκεται πάνω αριστερά. Στην demo έκδοση, μπορείτε να εισάγετε οποιονδήποτε αριθμό ή να αφήσετε το πεδίο κενό και να πατήσετε Enter για να πραγματοποιήσετε την αναζήτηση.
                </Typography>
              }
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary={
                <Typography variant="subtitle2">
                  <span style={{ fontWeight: 'bold' }}>Πληροφορίες και στατιστικά:</span> Αποκτήστε πρόσβαση σε χρήσιμα στατιστικά δεδομένα και πληροφορίες χρήσης της εφαρμογής, πάνω δεξιά (i).
                </Typography>
              }
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary={
                <Typography variant="subtitle2">
                  <span style={{ fontWeight: 'bold' }}>Καταχώρηση επισκέψεων ΕΟΠΥΥ:</span> Για να καταχωρήσετε τις ολοκληρωμένες επισκέψεις σας στον ΕΟΠΥΥ, κάντε κλικ στο κουμπί Ε-ΔΑΠΥ που βρίσκεται κάτω δεξιά.
                </Typography>
              }
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary={
                <Typography variant="subtitle2">
                  <span style={{ fontWeight: 'bold' }}>Βοήθεια:</span> Στην κάτω αριστερή γωνία της οθόνης, θα βρείτε ένα ερωτηματικό. Κάνοντας κλικ σε αυτό, μπορείτε να ενεργοποιήσετε ή να απενεργοποιήσετε τα μηνύματα βοήθειας. Αυτά τα μηνύματα εμφανίζονται όταν τοποθετείτε τον κέρσορα του ποντικιού πάνω από διάφορα πεδία της εφαρμογής, παρέχοντας χρήσιμες οδηγίες.
                </Typography>
              }
            />
          </ListItem>
        </List>
      </>
      })
    }

  
  }, [])
    
  



  return (

        logged===true ?
        <div  style={{ margin:"1rem", position: 'relative'}}> 

          <HelperPoper/>
          <PrescriptionDashboard/>
          <DemoMessage/>
          

          <Grid 
            container 
            spacing={3} 
            direction="row" 
            justifyContent="space-between"
           
          >

            <Grow in={grow} timeout="auto">
              <Grid className="amkaSearch" item xs={9} sm={5} md={5} lg={4} xl={3}>
                <PatientSearch/>
              </Grid>
            </Grow>

            <Grow in={grow} timeout="auto">
              <Grid  >
              <DocInformation/>
              </Grid>
            </Grow>

           

            <Grow in={grow} timeout="auto">
              <Grid item xs={12}>
                <Visits/>
              </Grid>
            </Grow>
            <Grow in={grow} timeout="auto">
            <Grid item xs={12} container justifyContent="flex-end">
              <Button style={{right:20}} onClick={()=>setDemoMessage({
                status:true,
                severity:"info",
                description:"το κουμπί αυτό θα καταχωρήσει τις ημερήσιες επισκέψεις σας στο eΔΑΠΥ"
              })} color="primary" variant="outlined">
                Ε-ΔΑΠΥ
              </Button>
              </Grid>
            </Grow>

            <DemoDialog/>

          </Grid>
              
        </div> 
        : 
        <Navigate to="/"/>
   
  )
}
export const DemoMessage = () => {
        
  const demoMessage = useDemoStore(state => state.demoMessage)
  const setDemoMessage = useDemoStore(state => state.setDemoMessage)

  const handleClose = ()=>{
    setDemoMessage({
      status:false,
      severity:"",
      description:""
    })
  }

  return(        
      <Snackbar open={demoMessage.status} autoHideDuration={5000} onClose={handleClose}>
          <Alert 
          onClose={handleClose} 
          variant='filled'
          severity={demoMessage.severity}
          >
          {demoMessage.generic ? demoMessage.description : `Βρίσκεστε αυτή τη στιγμή στο δοκιμαστικό περιβάλλον της εφαρμογής. Στο παραγωγικό περιβάλλον, ${demoMessage.description} ` }
          </Alert>
      </Snackbar>
  )
} 
export const DemoDialog = () => {
        
  const demoDialog = useDemoStore(state => state.demoDialog)
  const setDemoDialog = useDemoStore(state => state.setDemoDialog)

  const closeDialog = ()=>{
    setDemoDialog({
      status:false,
      description:""
    })
  }

  return (
    <>


      <Dialog maxWidth='md' open={demoDialog.status} onClose={()=>closeDialog()}>
        <DialogTitle> i-prescription</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {demoDialog.description}
          </DialogContentText>
         
      
          

        </DialogContent>
        <DialogActions>
          <Button onClick={()=>closeDialog()} color="secondary">
            OK
          </Button>

        </DialogActions>
      </Dialog>
    
    </>      
  )
} 


